export default {
  'txt-board': 'Bảng giá',
  'txt-trade': 'Giao dịch',
  'txt-market-analysis': 'Thống kê thị trường',
  'txt-trade-acronym': 'GD',
  'txt-cash-transfer': 'nạp/rút tiền',
  'txt-asset': 'Tài sản',
  'txt-total-asset': 'Tổng tài sản',
  'txt-cash-advance': 'Ứng trước tiền bán',
  'txt-stock-transfer': 'Chuyển cổ phiếu',
  'txt-money-transfer': 'Chuyển tiền giữa các tiểu khoản',
  'txt-margin-debt': 'Công nợ margin',
  'txt-deposit-withdrawal': 'Nạp / rút tiền',
  'txt-reference-subcription': 'Tra cứu / đăng ký quyền',
  'txt-hold-unhold': 'Phong toả / Giải toả tiền',

  'txt-order': 'Đặt lệnh',
  'txt-rate': 'Tỷ lệ',
  'txt-login': 'Đăng nhập',
  'txt-xacthuc': 'Xác thực',
  'txt-cancel': 'Huỷ',
  'txt-re-login': 'Đăng nhập lại',
  'txt-order-confirm': 'Xác nhận lệnh',
  'txt-ignore': 'Bỏ qua',
  'txt-detail': 'Chi tiết',
  'txt-move': 'Chuyển',
  'txt-moved': 'Đã chuyển',
  'txt-registration': 'Đăng ký mua',
  'txt-accept': 'Xác nhận',
  'txt-clear': 'Xoá',
  'txt-regis-bank-account': 'Đăng ký tài khoản ngân hàng',
  'txt-change': 'Thay đổi',
  'txt-change-per': 'Thay đổi %',
  'txt-change-pass': 'Đổi mật khẩu',
  'txt-change-account': 'Đổi tài khoản',
  'txt-change-login-account': 'Đổi tài khoản đăng nhập',
  'txt-register': 'Đăng ký',
  'txt-btn-order-cond': 'Đặt lệnh ĐK',

  'txt-day': 'ngày',
  'txt-coso': 'Cơ sở',
  'txt-phaisinh': 'Phái sinh',
  'txt-notice': 'Thông báo',
  'txt-search': 'Tìm kiếm',
  'txt-add-symbol': 'Thêm mã CK',
  'txt-da-xacthuc': 'Đã xác thực',
  'txt-chua-xacthuc': 'Chưa xác thực',
  'txt-sub-account': 'Tiểu khoản',
  'txt-normal': 'Thường',
  'txt-utilities': 'Tiện ích',
  'txt-contact': 'Liên hệ',
  'txt-guide': 'Hướng dẫn',
  'txt-sign-out': 'Thoát',
  'txt-update': 'Cập nhật',
  'txt-nav': 'Tài sản ròng',
  'txt-stock-val': 'Giá trị thị trường CK',
  'txt-pp': 'Sức mua',
  'txt-pp-margin': 'Sức mua margin',
  'txt-cashbalance': 'Tiền mặt thực có',
  'txt-wdrawAvail': 'Tiền được rút',
  'txt-advanceAvail': 'Tiền bán chờ về',
  'txt-stock-waiting': 'CK chờ về',
  'txt-collateral': 'Cổ tức tiền',
  'txt-debt': 'Nợ',
  'txt-depoFee': 'Phí lưu ký',
  'txt-total-depoFee': 'Tổng phí lưu ký',
  'txt-margin-limit': 'Hạn mức margin',
  'txt-buy-max': 'KL có thể mua',
  'txt-sell-max': 'KL có thể bán',
  'txt-margin-rate': 'Tỷ lệ cho vay',

  'txt-cw': 'Chứng quyền',
  'txt-tp': 'Trái phiếu',
  'txt-cs': 'Cơ sở',
  'txt-ps': 'Phái sinh',
  'txt-pt': 'Thoả thuận',
  'txt-market': 'Sàn',
  'txt-symbol-name': 'Tên doanh nghiệp',

  'txt-portfolio': 'Danh mục',
  'txt-balance': 'Số dư',

  'txt-symbol': 'Mã CK',
  'txt-stock': 'Mã CP',
  'txt-info': 'Thông tin',
  'txt-max-margin-rate': 'Tỷ lệ cho vay',
  'txt-ref': 'T.C',
  'txt-ceil': 'Trần',
  'txt-floor': 'Sàn',
  'txt-bid': 'Bên mua',
  'txt-ask': 'Bên bán',
  'txt-price': 'Giá',
  'txt-stick-size': 'Bước giá',
  'txt-vol': 'KL',
  'txt-origin-vol': 'KL gốc',
  'txt-match': 'Khớp lệnh',
  'txt-total-vol': 'Tổng KL',
  'txt-oi': 'KL mở',
  'txt-total-val': 'Tổng GT',
  'txt-high': 'Cao',
  'txt-low': 'Thấp',
  'txt-ave': 'TB',
  'txt-price-ave': 'Giá TB',
  'txt-price-close': 'Giá đóng cửa',
  'txt-price-open': 'Giá mở của',
  'txt-total-num': 'Tổng số',
  'txt-foreign': 'Khối ngoại',
  'txt-buy': 'Mua',
  'txt-sell': 'Bán',
  'txt-order-no': 'SHL',
  'txt-origin-order-no': 'SHL gốc',
  'txt-type': 'Loại',
  // 'txt-price': 'Giá đặt',
  'txt-price-order': 'Giá đặt',
  'txt-match-vol': 'KL khớp',
  'txt-match-price': 'Giá khớp',
  'txt-cancel-vol': 'KL huỷ',
  'txt-total-match-value': 'Tổng GT khớp',
  'txt-status': 'Trạng thái',
  'txt-actions': 'Thao tác',
  'txt-market-price': 'Giá TT',
  'txt-gain-loss': 'Lãi/lỗ',
  'txt-orders': 'Sổ lệnh',
  'txt-help': 'Trợ giúp',
  'txt-to': 'đến',
  'txt-add-to': 'Thêm vào',
  'txt-vol-buy': 'KL Mua',
  'txt-vol-sell': 'KL Bán',
  'txt-total-match-vol': 'Tổng khối lượng Khớp lệnh',
  'txt-total-match-val': 'Tổng giá trị Khớp lệnh',
  'txt-lowest': 'Thấp nhất',
  'txt-highest': 'Cao nhất',

  'txt-order-normal': 'Lệnh thường',
  'txt-order-margin': 'Lệnh Margin',
  'txt-order-cond': 'Lệnh điều kiện',

  'txt-stt': 'STT',
  'txt-time': 'Thời gian',
  'txt-giatri': 'Giá trị',

  'txt-login-account': 'Đăng nhập tài khoản Thien Viet Securities',
  'txt-account': 'Tài khoản',
  'txt-account-acronym': 'TK',
  'txt-account-number': 'Số tài khoản',
  'txt-pass': 'Mật khẩu',
  'txt-all': 'Tất cả',
  'txt-closed': 'Đóng cửa',
  'txt-opened': 'Mở cửa',
  'txt-intermission': 'Nghỉ trưa',
  'txt-preopen': 'ATO',
  'txt-atc': 'ATC',
  'txt-c': 'Thoả thuận',
  'txt-plo': 'PLO',
  'txt-offline': 'Tại sàn',

  'txt-reserved': 'Lệnh chờ vào sở',
  'txt-sent': 'Chờ XN',
  'txt-confirm': 'Chờ khớp',
  'txt-matched': 'Khớp hết',
  'txt-part-matched': 'Khớp 1 phần',
  'txt-canceled': 'Đã huỷ',
  'txt-pending': 'Chờ xác nhận huỷ/sửa',
  'txt-transfer-pending': 'Đang chờ',
  'txt-complete': 'Hoàn thành',
  'txt-bank-error': 'Có lỗi từ bank',
  'txt-admended': 'Đã sửa',
  'txt-rejected': 'Từ chối',
  'txt-error-order': 'Lệnh bị lỗi',
  'txt-expired': 'Lệnh hết hiệu lực',

  'txt-success': 'Thành công',
  'txt-unsuccessful': 'Không thành công',

  'txt-match-order-vol': 'Khớp đủ khối lượng đặt',
  'txt-match-one-time': 'Một lần khớp duy nhất',
  'txt-out-time': 'Lệnh trước ngày',
  'txt-trend-order': 'Lệnh xu hướng',
  'txt-take-profit': 'Lệnh chốt lời',
  'txt-stop-loss': 'Lệnh cắt lỗ',
  'txt-purchase-order': 'Lệnh tranh mua / bán',
  'txt-transfer-content': 'Nop tien TK GDCK',

  'txt-cond-pending': 'Chờ kích hoạt',
  'txt-cond-active': 'Đang kích hoạt',
  'txt-cond-activated': 'Đã kích hoạt',
  'txt-cond-final': 'Kết thúc',
  'txt-cond-expired': 'Hết hiệu lực',
  'txt-cond-cancelling': 'Đang huỷ',
  'txt-cond-wait-react': 'Chờ kích hoạt lại',
  'txt-cond-effective-time': 'Thời gian hiệu lực',
  'txt-cond-setting-condition': 'Điều kiện đặt lệnh',
  'txt-cond-setting-price': 'Điều kiện giá',
  'txt-cond-method-trend': 'Phương thức xác định xu hướng',
  'txt-cond-pause-value': 'Khoảng dừng theo giá trị',
  'txt-cond-pause-per': 'Khoảng dừng theo %',
  'txt-cond-choose-price': 'Tuỳ chọn giá',
  'txt-cond-diff-price': 'Giá chênh lệch TP',
  'txt-cond-lowest-price': 'Giá mua thấp nhất',
  'txt-cond-highest-price': 'Giá bán cao nhất',
  'txt-cond-activation-conditions': 'Điều kiện kích hoạt',
  'txt-cond-avg': 'Giá mua Bình quân',
  'txt-cond-diff-for-avg': 'Chênh lệch so với giá BQ',
  'txt-cond-diff-for-avg-per': 'Giá trị chênh lệch',
  'txt-cond-diff-for-cur-price': 'Chênh lệch với giá hiện tại',
  'txt-cond-total-cond': 'Tổng kết điều kiện kích hoạt',

  'txt-open-account': 'Mở tài khoản »',
  'txt-forgot-pass': 'Quên mật khẩu?',
  'txt-no-data-found': 'Không có dữ liệu!',
  'txt-no-add-catalog': 'Không thêm mã vào danh mục ',
  'txt-symbol-has-in-catalog': 'Chứng khoán đã ở trong danh mục: ',
  'txt-price-not-match': 'Giá đặt không hợp lệ',
  'txt-cash-not-match': 'Số tiền không hợp lệ',
  'txt-no-beneficiary-data': 'Không có dữ liệu người thụ hưởng',
  'txt-vol-not-match': 'Khối lượng không hợp lệ',
  'txt-symbol-not-match': 'Chứng khoán không hợp lệ',
  'txt-price-not-over': 'Giá đặt không được vượt quá giá trần: ',
  'txt-price-not-less': 'Giá đặt không được nhỏ hơn giá sàn: ',
  'txt-hsx-price': 'HSX không đặt giá MTL/MOK/MAK/PLO',
  'txt-hnx-price': 'HNX không đặt giá MP',
  'txt-upcom-price': 'UPCOM không đặt giá thị trường',
  'txt-valid-time': 'Thời gian tìm kiếm không hợp lệ',
  'txt-valid-range-time': 'Chỉ được xuất báo cáo trong vòng',
  'txt-valid-5-catalog': 'Thêm tối đa 15 danh mục',
  'txt-valid-not-del': 'Không được xoá ',
  'txt-valid-not-edit': 'Không được sửa ',
  'txt-valid-excess-amount': 'Số tiền vượt quá số tiền có thể chuyển',
  'txt-valid-max-amount': 'Ứng tối đa',
  'txt-valid-min-amount': 'Ứng tối thiểu',
  'txt-valid-send-otp': 'Không được gửi quá 05 OTP trong vòng 2 phút!',
  'txt-valid-same-pass': 'Mật khẩu mới và mật khẩu cũ trùng nhau',
  'txt-valid-pass-confirm-not-match':
    'Mật khẩu mới và nhập lại mật khẩu không trùng nhau',
  'txt-valid-input-required': 'Trường không được để trống',
  'txt-valid-characters': 'ký tự',
  'txt-valid-enter': 'Nhập',
  'txt-valid-phone-incorrect-format':
    'Số điện thoại của bạn không đúng định dạng',
  'txt-valid-date-incorrect-format': 'Ngày sinh của bạn không đúng định dạng',
  'txt-valid-email-incorrect-format': 'Email không đúng định dạng',
  'txt-valid-enter-verification-code': 'Hãy nhập mã xác thực',
  'txt-valid-loss-session':
    'Mất session. Quý khách cần đăng nhập lại để tiếp tục',
  'txt-valid-old-account-not-match': 'Tài khoản cũ không trùng User đăng nhập',
  'txt-valid-same-new-account': 'Tài khoản mới và tài khoản cũ giống nhau',

  'txt-show': 'Thể hiện',
  'text-order': 'lệnh',
  'txt-overview': 'Tổng quan (tỷ VNĐ)',
  'txt-all-market': 'Toàn thị trường',
  'txt-total-transaction': 'Tổng GD',
  'txt-total-putThrough': 'Tổng GDTT',
  'txt-total-foreign': 'Khối ngoại',
  'txt-international': 'TT Quốc tế',

  'txt-orderNo': 'Số hiệu lệnh',
  'txt-lost-connect': 'Mất kết nối đến server',
  'txt-regis-unsuccessful': 'Đăng ký private không thành công',

  'txt-title-order-cond': 'Đặt lệnh điều kiện',
  'txt-title-authentication-success': 'Xác thực thành công',
  'txt-title-neworder-success': 'Đặt lệnh thành công',
  'txt-title-neworder-unsuccess': 'Đặt lệnh không thành công',
  'txt-title-delorder-success': 'Huỷ lệnh thành công',
  'txt-title-editorder-success': 'Sửa lệnh thành công',
  'txt-title-hold-success': 'Phong toả / Giải toả ngân hàng thành công!',
  'txt-title-asset-manage': 'Báo cáo tài sản',
  'txt-title-debt-manage': 'Báo cáo nợ',
  'txt-title-transfer-stock-fail': 'Chuyển cổ phiếu không thành công',
  'txt-title-transfer-success': 'Đã chuyển thành công',
  'txt-title-login-success': 'Đăng nhập thành công',
  'txt-title-changepass-success':
    'Đổi mật khẩu thành công. Quý khách cần đăng nhập lại để tiếp tục',
  'txt-title-max': 'Tối đa',
  'txt-title-min': 'Tối thiểu',
  'txt-title-withdrawal-confirmation': 'Xác nhận rút tiền',
  'txt-title-withdrawal-verification': 'Xác thực rút tiền',
  'txt-title-edit-confirm': 'Xác nhận sửa lệnh',
  'txt-title-new-confirm': 'Xác nhận đặt lệnh',
  'txt-title-delete-confirm': 'Xác nhận huỷ lệnh',
  'txt-title-fill-info-regis':
    'Điền thông tin bạn đã đăng ký với Thien Viet Securities',
  'txt-title-login-no-cif': 'Thông tin khách hàng chưa chính xác',

  'txt-stt-in-date': 'Trong hạn',
  'txt-stt-due-date': 'Đến hạn',
  'txt-stt-out-date': 'Quá hạn',
  'txt-stt-right-cash': 'Quyền tiền',
  'txt-stt-right-buy': 'Quyền mua',
  'txt-stt-right-stock': 'Quyền cổ phiếu',
  'txt-stt-internal': 'Nội bộ',
  'txt-stt-bank': 'Ngân hàng',

  'txt-stt-right-01': 'Cổ tức bằng tiền',
  'txt-stt-right-02': 'Cổ tức bằng cổ phiếu',
  'txt-stt-right-03': 'Quyền mua',
  'txt-stt-right-04': 'Cổ phiếu thưởng',
  'txt-stt-right-05': 'Giảm vốn tự nguyệ',
  'txt-stt-right-06': 'Giảm vốn bắt buộc',
  'txt-stt-right-07': 'Sáp nhập và hợp nhất',
  'txt-stt-right-08': 'Chia tách công ty',
  'txt-stt-right-09': 'Đổi mã giao dịch',
  'txt-stt-right-11': 'Chia tách cổ phiếu',
  'txt-stt-right-12': 'Gộp cổ phiếu',

  'txt-asset-total': 'Tổng tài sản',
  'txt-asset-nav': 'Tài sản ròng',
  'txt-asset-withdraw': 'Số tiền được rút',
  'txt-asset-receivable': 'Số tiền tối đa được ứng',
  'txt-asset-withdrawal': 'Tiền được rút',
  'txt-asset-receivable-1': 'Tiền tối đa được ứng',
  'txt-asset-balance': 'Tiền',
  'txt-asset-cash-balance': 'Số dư tiền',
  'txt-asset-actual-balance-account': 'Số dư tiền thực tế trên tài khoản',
  'txt-asset-receivable-amount': 'Tiền chờ về',
  'txt-asset-buy-mount': 'Tiền mua đã khớp',
  'txt-asset-unmatch-amount': 'Tiền mua chưa khớp',
  'txt-asset-collateral': 'Cổ tức tiền chờ về',
  'txt-asset-collateral-stock': 'Cổ tức CK chờ về',
  'txt-asset-stocks': 'Giá trị chứng khoán',
  'txt-asset-market-stocks': 'Giá trị thị trường của CK',
  'txt-asset-guaranteed': 'Giá trị tài sản cần đảm bảo',
  'txt-asset-outstanding-debt': 'Dư nợ thực tế',
  'txt-asset-adding': 'Số tiền cần bổ sung',
  'txt-asset-remain-margin': 'Hạn mức còn lại',
  'txt-asset-day-loan': 'Nợ vay Margin trong ngày',
  'txt-asset-principal': 'Nợ gốc Margin',
  'txt-asset-month-depo-fee': 'Tổng phí lưu ký',
  'txt-asset-other-fee': 'Phí SMS',
  'txt-asset-cash-can-transfer': 'Số tiền có thể chuyển',
  'txt-asset-margin-loan-interest': 'Lãi vay Margin',

  'txt-label-page': 'Trang',
  'txt-label-cash': 'Tiền',
  'txt-label-avail': 'GD',
  'txt-label-position': 'Chứng khoán',
  'txt-label-from': 'Từ ngày',
  'txt-label-to': 'Đến ngày',
  'txt-label-right': 'Quyền',
  'txt-label-total-loan': 'Tổng dư nợ',
  'txt-label-loan-date': 'Ngày vay',
  'txt-label-expire-date': 'Ngày đến hạn',
  'txt-label-expired-date': 'Ngày hết hạn',
  'txt-label-interest': 'Lãi',
  'txt-label-fee': 'Phí',
  'txt-label-tax': 'Thuế',
  'txt-label-free': 'Miễn phí',
  'txt-label-defer-interest': 'Lãi chậm hạn',
  'txt-label-repay-interest': 'Số tiền thanh toán',
  'txt-label-remain-interest': 'Nợ còn lại',
  'txt-label-disbursement-date': 'Ngày giải ngân',
  'txt-label-maturity-date': 'Hạn',
  'txt-label-interest-rate': 'Lãi suất / năm',
  'txt-label-loan-amount': 'Số tiền vay',
  'txt-label-penalty-delay': 'Phạt chậm hạn',
  'txt-label-paid': 'Đã trả',
  'txt-label-unpaid': 'Chưa trả',
  'txt-label-repay': 'Đã hoàn ứng',
  'txt-label-unrepay': 'Chờ hoàn ứng',
  'txt-label-in-due-amount': 'Còn nợ',
  'txt-label-pay': 'Thanh toán',
  'txt-label-total-amount': 'Thành tiền',
  'txt-label-real-amount': 'GT thực tế',
  'txt-label-payment-history': 'Lịch sử thanh toán',
  'txt-label-return-asset': 'Quay lại tổng quan tài sản',
  'txt-label-major': 'Nghiệp vụ',
  'txt-label-opening-balance': 'Số dư đầu kỳ',
  'txt-label-closing-balance': 'Số dư cuối kỳ',
  'txt-label-increase': 'Phát sinh tăng',
  'txt-label-decrease': 'Phát sinh giảm',
  'txt-label-vol-up': 'KL tăng',
  'txt-label-vol-down': 'KL giảm',
  'txt-label-remark': 'Mô tả',
  'txt-label-overview': 'Tổng quan',
  'txt-label-history-price': 'Lịch sử giá',
  'txt-label-finance': 'Tài chính',
  'txt-label-events': 'Sự kiện',
  'txt-label-news': 'Tin tức',
  'txt-label-documents': 'Hồ sơ',
  'txt-label-details': 'Chi tiết giá',
  'txt-label-amount': 'Số lượng',
  'txt-label-expected-date': 'Ngày chốt quyền',
  'txt-label-registration-date': 'Ngày thực hiện quyền',
  'txt-label-quantity-record-date': 'SL tại ngày chốt',
  'txt-label-ratio': 'Tỷ lệ',
  'txt-label-pending-transfer': 'Chờ chuyển',
  'txt-label-pending-delivery': 'Chờ giao',
  'txt-label-pending-trading': 'CK chờ GD',
  'txt-label-tran-date': 'Ngày GD',
  'txt-label-tran-amount': 'Số tiền',
  'txt-label-tran-type': 'Loại GD',
  'txt-label-deposit': 'Nộp tiền',
  'txt-label-withdrawal': 'Rút tiền',
  'txt-label-hold-bank': 'Tạm giữ tại ngân hàng',
  'txt-label-withdrawal-bank': 'Rút từ ngân hàng',
  'txt-label-bank-link': 'Ngân hàng đã liên kết',
  'txt-label-bank-name': 'Tên ngân hàng',
  'txt-label-branch-name': 'Tên chi nhánh',
  'txt-label-bank-account': 'Số tài khoản',
  'txt-label-bank-hold-amount': 'Số tiền tạm giữ',
  'txt-label-history': 'Lịch sử',
  'txt-label-transfer-to': 'Chuyển sang',
  'txt-label-source': 'Nguồn',
  'txt-label-target': 'Đích',
  'txt-label-create-date': 'Ngày tạo',
  'txt-label-stock-transfer': 'Chuyển cổ phiếu',
  'txt-label-stock-holding': 'Mã CP nắm giữ',
  'txt-label-vol-holding': 'KL nắm giữ',
  'txt-label-cash-transfer-amount': 'Số tiền chuyển',
  'txt-label-cash-transfer-content': 'Nội dung chuyển',
  'txt-label-internal-transfer': 'Chuyển tiền tiểu khoản',
  'txt-label-online-transfer': 'chuyển tiền online từ',
  'txt-label-right-subscription': 'Đăng ký quyền mua',
  'txt-label-max-subscription': 'Số tiền tối đa được đăng ký: ',
  'txt-label-owned-quantity': 'KL CK tại ngày chốt',
  'txt-label-remaining-quantity': 'KL được mua',
  'txt-label-purchased-quantity': 'KL đã mua',
  'txt-label-maximum-quantity': 'KL còn được mua',
  'txt-label-start-date': 'Ngày bắt đầu',
  'txt-label-end-date': 'Ngày kết thúc',
  'txt-label-base-date': 'Hạn đăng ký',
  'txt-label-market-value': 'Giá trị thị trường',
  'txt-label-buy-amt': 'Giá trị ban đầu',
  'txt-label-billion': 'tỷ',
  'txt-label-deposit-stock': 'Nạp tiền vào tài khoản CK',
  'txt-label-beneficiary': 'Tên người thụ hưởng',
  'txt-label-account-beneficiary': 'Tài khoản thụ hưởng',
  'txt-label-choose': 'Chọn',
  'txt-label-transfer-content': 'Nội dung chuyển khoản',
  'txt-label-amount-want-transfer': 'Số tiền muốn chuyển',
  'txt-label-source-advance': 'Nguồn ứng',
  'txt-label-amount-advance': 'Số tiền yêu cầu ứng',
  'txt-label-advance-request': 'Yêu cầu ứng',
  'txt-label-amount-deducted': 'Số tiền đã trừ',
  'txt-label-fee-service': 'Phí dịch vụ',
  'txt-label-fee-management': 'Phí quản lý',
  'txt-label-total': 'Tổng',
  'txt-label-sell-date': 'Ngày bán',
  'txt-label-trade-amount-af-fee': 'Tiền có thể ứng tối đa',
  'txt-label-settlement-date': 'Ngày về TK',
  'txt-label-calculator-fee': 'Tính phí ứng',
  'txt-label-deposit': 'Nạp tiền',
  'txt-label-withdrawal': 'Rút tiền',
  'txt-label-profile': 'Hồ sơ',
  'txt-label-security': 'Bảo mật',
  'txt-label-bank-account': 'Tài khoản ngân hàng',
  'txt-label-authorization': 'Người uỷ quyền',
  'txt-label-authorization-person': 'Người uỷ quyền',
  'txt-label-authorization-person-other': 'Người uỷ quyền khác',
  'txt-label-authorization-type': 'Loại GD được uỷ quyền',
  'txt-label-order-statement': 'Sao kê sổ lệnh',
  'txt-label-order-cond-statement': 'Sao kê lệnh ĐK',
  'txt-label-cash-statement': 'Sao kê tiền',
  'txt-label-securities-statement': 'Sao kê chứng khoán',
  'txt-label-order-del': 'Huỷ lệnh',
  'txt-label-order-edit': 'Sửa lệnh',
  'txt-label-trading-fee': 'Phí GD',
  'txt-label-condition': 'Điều kiện',
  'txt-label-order-history': 'Lịch sử đặt lệnh',
  'txt-label-order-cond-history': 'Lịch sử đặt lệnh điều kiện',
  'txt-label-channel': 'Kênh đặt',
  'txt-label-account-info': 'Thông tin cá nhân',
  'txt-label-fullname': 'Họ và tên',
  'txt-label-identification': 'CMND',
  'txt-label-issued-on': 'Ngày cấp',
  'txt-label-place': 'Nơi cấp',
  'txt-label-phone-num': 'Số điện thoại di động',
  'txt-label-phone': 'Số điện thoại',
  'txt-label-date-birth': 'Ngày sinh',
  'txt-label-sex': 'Giới tính',
  'txt-label-cif-no': 'Số CIF',
  'txt-label-vsd-no': 'Số VSD',
  'txt-label-male': 'Nam',
  'txt-label-female': 'Nữ',
  'txt-label-nationality': 'Quốc tịch',
  'txt-label-contact-info': 'Thông tin liên hệ',
  'txt-label-permanent-address': 'Địa chỉ thường trú',
  'txt-label-address': 'Địa chỉ liên hệ',
  'txt-label-province': 'Tỉnh / Thành phố',
  'txt-label-branch': 'Chi nhánh',
  'txt-label-beneficiary-bank': 'Ngân hàng thụ hưởng',
  'txt-label-account-holder': 'Chủ tài khoản',
  'txt-label-account-num': 'Số tài khoản',
  'txt-label-account-second': 'Tài khoản phụ',
  'txt-label-login-info': 'Thông tin đăng nhập',
  'txt-label-login-account': 'Tên đăng nhập',
  'txt-label-customer-name': 'Tên khách hàng',
  'txt-label-current-password': 'Mật khẩu hiện tại',
  'txt-label-default-account': 'Tài khoản mặc định',
  'txt-label-authentication-registered': 'Các PTXT bạn đang đăng ký',
  'txt-label-change-pass-pinetree':
    'Đổi mật khẩu tài khoản Thien Viet Securities',
  'txt-label-old-pass': 'Mật khẩu cũ',
  'txt-label-new-pass': 'Mật khẩu mới',
  'txt-label-new-pass-confirm': 'Nhập lại mật khẩu mới',
  'txt-label-authen-otp': 'Xác thực OTP',
  'txt-label-cash-advance': 'Được ứng',
  'txt-label-recipient-account': 'Tài khoản nhận',
  'txt-label-amount-withdraw': 'Số tiền muốn rút',
  'txt-label-margin-list': 'CK ký quỹ',
  'txt-label-look-right-info': 'Tra cứu thông tin thực hiện quyền',
  'txt-label-default-watchlist': 'Mặc định',
  'txt-label-cash-advance-payment': 'Tiền bán có thể ứng',
  'txt-label-old-account': 'Tài khoản cũ',
  'txt-label-new-account': 'Tài khoản mới',
  'txt-label-quarterly': 'Dữ liệu quý',
  'txt-label-annual': 'Dữ liệu năm',
  'txt-label-income-statement': 'Kết quả kinh doanh',
  'txt-label-balance-sheet': 'Cân đối kế toán',
  'txt-label-ratios': 'Chỉ số tài chính',
  'txt-label-items': 'Chỉ số',
  'txt-label-today': 'Hôm nay',
  'txt-label-month': 'Tháng',
  'txt-label-monday': 'T2',
  'txt-label-tuesday': 'T3',
  'txt-label-wednesday': 'T4',
  'txt-label-thursday': 'T5',
  'txt-label-friday': 'T6',
  'txt-label-saturday': 'T7',
  'txt-label-sunday': 'CN',
  'txt-label-major-shareholders': 'Cổ đông chính',
  'txt-label-legal-representative': 'Ban lãnh đạo',
  'txt-label-CS': 'CS',

  'txt-export-excel': 'Xuất Excel',
  'txt-export-pdf': 'Xuất PDF',

  'txt-verification-methods': 'Chọn Phương Thức Xác Thực',
  'txt-choose-verification-methods': 'Vui lòng chọn 1 trong các PTXT dưới đây',
  'txt-smartotp-pinetree':
    'Sử dụng ứng dụng SmartOTP của Thien Viet Securities',
  'txt-matrix': 'Ma trận',
  'txt-regis-counter': 'Đăng ký tại quầy',
  'txt-otp-sent-to': 'OTP sẽ gửi về SĐT ',
  'txt-lost-verification': 'Mất PTXT?',

  'txt-enter-otp': 'Nhập mã OTP của bạn',
  'txt-sub-smartotp':
    'Vui lòng nhập mã hiển thị tại ứng dụng SmartOTP của bạn vào ô dưới đây',
  'txt-sub-otp': 'Vui lòng nhập mã OTP đã được gửi về SDT',
  'txt-learn-more': 'Tìm hiểu thêm',
  'txt-cant-access': 'Chưa thể truy cập thiết bị của bạn?',
  'txt-change-method': 'Thay đổi Phương Thức Xác Thực khác',
  'txt-resend': 'Gửi lại',
  'txt-enter-matrix': 'Nhập mã ma trận của bạn',
  'txt-hotline-support':
    'Bạn muốn thay đổi các thông tin hồ sơ trên ? Vui lòng liên hệ hotline của Thien Viet Securities để được hỗ trợ.',
  'txt-make-sure-can-access':
    'Hãy chắc chắn bạn có thể truy cập phương thức xác thực hiện tại để thực hiện thay đổi các thông tin bảo mật tài khoản',
  'txt-make-verify-otp-correct': 'Xác thực OTP sau khi nhập đúng cả 2 password',
  'txt-code-smartotp-to-confirm':
    'Quý khách hãy nhập mã số bảo mật từ ứng dụng SmartOTP để xác nhận giao dịch',
  'txt-code-otp-to-confirm': 'Quý khách hãy nhập mã số OTP được gửi đến SDT',
  'txt-confirm-transaction': 'để xác nhận giao dịch',
  'txt-code-matrix-to-confirm':
    'Quý khách hãy nhập mã MATRIX để xác nhận giao dịch',
  'txt-gd':
    'Để thực hiện nạp tiền vào tài khoản Chứng khoán tự động. Quý khách vui lòng thực hiện chuyển khoản Ngân hàng tới 1 trong số các tài khoản Ngân hàng với thông tin CHÍNH XÁC như mẫu',
  'txt-warning-cashout-fee':
    'Số tiền rút tối đa chưa bao gồm phí smsOTP (nếu có)',
  'txt-warning-cashout':
    'Hệ thống hỗ trợ rút tiền online từ 08h00 tới 15h30 hàng ngày, quý khách vui lòng thực hiện trong khoảng thời gian trên',
  'txt-warning-relogin': 'Bạn đã dăng xuất, vui lòng đăng nhập lại.',

  'algo.menu.txt-ptdt': 'Phân tích đầu tư',
  'algo.menu.txt-bdkt': 'Biểu đồ kỹ thuật',
  'algo.menu.txt-pttt': 'Phân tích thị trường',
  'algo.menu.txt-ptcp': 'Phân tích cổ phiếu',
  'algo.menu.txt-lcp': 'Lọc cổ phiếu',
  'algo.menu.txt-thcb': 'Lọc tín hiệu',

  'algo.bdkt.txt-overview': 'Tổng hợp',
  'algo.bdkt.txt-money-flows': 'Dòng tiền',
  'algo.bdkt.txt-statistical': 'Thống kê',
  'algo.bdkt.txt-overview-2': 'Tổng quan',
  'algo.bdkt.txt-reference-index': 'Tham chiếu',
  'algo.bdkt.txt-Open-Index': 'Mở cửa',
  'algo.bdkt.txt-low-high': 'Thấp - Cao',
  'algo.bdkt.txt-trading-volume': 'Khối lượng',
  'algo.bdkt.txt-trading-value': 'Giá trị',
  'algo.bdkt.txt-bil': 'tỷ',
  'algo.bdkt.txt-foreigner-trading': 'Giao dịch NĐTNN',
  'algo.bdkt.txt-buy-vol': 'KL Mua',
  'algo.bdkt.txt-sell-vol': 'KL Bán',
  'algo.bdkt.txt-net-buy-vol': 'KL Mua ròng',
  'algo.bdkt.txt-buy-val': 'GT Mua',
  'algo.bdkt.txt-sell-val': 'GT Bán',
  'algo.bdkt.txt-net-buy-val': 'GT Mua ròng',
  'algo.bdkt.txt-foreigner-buy-val': 'NN Mua ròng',
  'algo.bdkt.txt-intraday': 'Hôm nay',
  'algo.bdkt.txt-10-day': '10 phiên',
  'algo.bdkt.txt-advance-decline-nochange': 'Số lượng CP Tăng, Giảm, Không đổi',
  'algo.bdkt.txt-no-change': 'Không đổi',
  'algo.bdkt.txt-decline': 'Giảm',
  'algo.bdkt.txt-advance': 'Tăng',
  'algo.bdkt.txt-money-flow-distribution': 'Phân bổ dòng tiền',

  'algo.pttt.txt-market': 'Thị trường',
  'algo.pttt.txt-institutions': 'Tổ chức',
  'algo.pttt.txt-industry': 'Ngành',
  'algo.pttt.txt-money-flow': 'Dòng tiền',
  'algo.pttt.txt-matching': 'Khớp lệnh',
  'algo.pttt.txt-matching-putthrough': 'Khớp lệnh và thỏa thuận',
  'algo.pttt.txt-contribution-index': 'TOP ẢNH HƯỞNG ĐẾN INDEX',
  'algo.pttt.txt-contrib-index-per': 'Đóng góp vào Index (%)',
  'algo.pttt.txt-contrib-index-point': 'Đóng góp vào Index (điểm)',
  'algo.pttt.txt-trading-volume': 'KHỐI LƯỢNG GIAO DỊCH',
  'algo.pttt.txt-Liquidity': 'THANH KHOẢN',
  'algo.pttt.txt-Current': 'Hiện tại',
  'algo.pttt.txt-PreDay': 'Phiên trước',
  'algo.pttt.txt-1week': '1 tuần',
  'algo.pttt.txt-2week': '2 tuần',
  'algo.pttt.txt-1month': '1 tháng',
  'algo.pttt.txt-market-capitalization': 'BIỂU ĐỒ VỐN HÓA',
  'algo.pttt.txt-Foreigner-trading-volume': 'KHỐI LƯỢNG KHỐI NGOẠI MUA RÒNG',
  'algo.pttt.txt-Foreigner-trading-value': 'GIÁ TRỊ KHỐI NGOẠI MUA RÒNG',
  'algo.pttt.txt-Proprietary-trading-volume': 'KHỐI LƯỢNG TỰ DOANH MUA RÒNG',
  'algo.pttt.txt-Proprietary-trading-value': 'GIÁ TRỊ TỰ DOANH MUA RÒNG',
  'algo.pttt.txt-industry-contrib-index': 'TOP NGÀNH ẢNH HƯỞNG ĐẾN INDEX',
  'algo.pttt.txt-Foreigner-trading-by-industries':
    'KHỐI NGOẠI MUA RÒNG THEO NGÀNH',
  'algo.pttt.txt-Proprietary-trading-by-industries':
    'TỰ DOANH MUA RÒNG THEO NGÀNH',
  'algo.pttt.txt-Trading-value-by-industries': 'GIÁ TRỊ GIAO DỊCH THEO NGÀNH',
  'algo.pttt.txt-Market-breadth': 'ĐỘ RỘNG THỊ TRƯỜNG',
  'algo.pttt.txt-net-money-flow': 'DÒNG TIỀN RÒNG',
  'algo.pttt.txt-advance': 'Tăng',
  'algo.pttt.txt-no-change': 'Không thay đổi',
  'algo.pttt.txt-decline': 'Giảm',

  'algo.ptcp.txt-overview': 'Tổng quan',
  'algo.ptcp.txt-price-history': 'Lịch sử giá',
  'algo.ptcp.txt-Finance': 'Tài chính',
  'algo.ptcp.txt-Profile': 'Hồ sơ',
  'algo.ptcp.txt-Events': 'Sự kiện',
  'algo.ptcp.txt-News': 'Tin tức',
  'algo.ptcp.txt-Reference-Price': 'Tham chiếu',
  'algo.ptcp.txt-Open-price': 'Mở cửa',
  'algo.ptcp.txt-low-high': 'Thấp - Cao',
  'algo.ptcp.txt-trading-volume': 'Khối lượng',
  'algo.ptcp.txt-trading-value': 'Giá trị',
  'algo.ptcp.txt-10-day-avg-vol': 'KLTB 10 ngày',
  'algo.ptcp.txt-Market-cap': 'Vốn hóa',
  'algo.ptcp.txt-Outstanding-shares': 'Số lượng CPLH',
  'algo.ptcp.txt-Sector': 'Ngành',
  'algo.ptcp.txt-Order-book': 'Sổ lệnh',
  'algo.ptcp.txt-Best-bid': 'Đặt mua',
  'algo.ptcp.txt-Best-ask': 'Đặt bán',
  'algo.ptcp.txt-Matched-details': 'Lịch sử khớp',
  'algo.ptcp.txt-Matched-analysis': 'Phân tích KL',
  'algo.ptcp.txt-Active-buy-vol': 'KL Mua chủ động',
  'algo.ptcp.txt-Active-sell-vol': 'KL Bán chủ động',
  'algo.ptcp.txt-B': 'M',
  'algo.ptcp.txt-S': 'B',
  'algo.ptcp.txt-Money-Flow': 'Dòng tiền',
  'algo.ptcp.txt-Foreigner-trading': 'Giao dịch NĐTNN',
  'algo.ptcp.txt-Buy-vol': 'KL Mua',
  'algo.ptcp.txt-Sell-vol': 'KL Bán',
  'algo.ptcp.txt-Net-buy-vol': 'KL Mua ròng',
  'algo.ptcp.txt-Buy-val': 'GT Mua',
  'algo.ptcp.txt-Sell-val': 'GT Bán',
  'algo.ptcp.txt-Net-buy-val': 'GT Mua ròng',
  'algo.ptcp.txt-Foreigner-net-buy': 'NN Mua ròng',
  'algo.ptcp.txt-intraday': 'Hôm nay',
  'algo.ptcp.txt-10-days': '10 phiên',
  'algo.ptcp.txt-Search': 'Tìm kiếm',
  'algo.ptcp.txt-Trade-date': 'Ngày',
  'algo.ptcp.txt-Close-price': 'Giá đóng cửa',
  'algo.ptcp.txt-Change': 'Thay đổi',
  'algo.ptcp.txt-Ref-price': 'Giá tham chiếu',
  'algo.ptcp.txt-Foreigner-buy-vol': 'KL NN mua ròng',
  'algo.ptcp.txt-Proprietary-buy-vol': 'KL Tự doanh Mua ròng',
  'algo.ptcp.txt-matched': 'Khớp lệnh',
  'algo.ptcp.txt-put-through': 'Thỏa thuận',
  'algo.ptcp.txt-volume': 'KLGD',
  'algo.ptcp.txt-value': 'GTGD',
  'algo.ptcp.txt-Income-statement': 'Kết quả kinh doanh',
  'algo.ptcp.txt-Balance-sheet': 'Cân đối kế toán',
  'algo.ptcp.txt-Cash-flow-statement': 'Dòng tiền',
  'algo.ptcp.txt-Profitability': 'Khả năng sinh lời',
  'algo.ptcp.txt-Quarter': 'Quý',
  'algo.ptcp.txt-Year': 'Năm',
  'algo.ptcp.txt-bil-vnd': '(Đơn vị: Tỷ đồng)',
  'algo.ptcp.txt-unit-per': '(Đơn vị: %)',
  'algo.ptcp.txt-Net-revenue': 'Doanh thu thuần',
  'algo.ptcp.txt-Gross-profit': 'Lợi nhuận gộp',
  'algo.ptcp.txt-Operating-profit': 'Lợi nhuận từ HĐ kinh doanh',
  'algo.ptcp.txt-Net-profit': 'Lợi nhuận sau thuế',
  'algo.ptcp.txt-Total-assets': 'Tổng tài sản',
  'algo.ptcp.txt-Current-liabilities': 'Nợ ngắn hạn phải trả',
  'algo.ptcp.txt-Non-current-liabilities': 'Nợ dài hạn',
  'algo.ptcp.txt-Total-equity': 'Vốn chủ sở hữu',
  'algo.ptcp.txt-Operating-cash-flow': 'Dòng tiền từ hoạt động kinh doanh',
  'algo.ptcp.txt-Financing-cash-flow': 'Dòng tiền từ hoạt động tài chính',
  'algo.ptcp.txt-Investing-cash-flow': 'Dòng tiền từ hoạt động đầu tư',
  'algo.ptcp.txt-Free-cash-flow': 'Dòng tiền tự do',
  'algo.ptcp.txt-Gross-margin': 'Biên lợi nhuận gộp',
  'algo.ptcp.txt-Net-margin': 'Biên lợi nhuận ròng',
  'algo.ptcp.txt-Growth-Value-Quality': 'Tăng trưởng - Giá trị - Chất lượng',
  'algo.ptcp.txt-market': 'TT',
  'algo.ptcp.txt-val-12m': 'Giá trị(T12M)',
  'algo.ptcp.txt-EPS-growth': 'Tăng trưởng EPS(%)',
  'algo.ptcp.txt-Growth': 'Tăng trưởng (YoY)',
  'algo.ptcp.txt-Revenue': 'Doanh thu (%)',
  'algo.ptcp.txt-CAGR': 'CAGR (3 năm)',
  'algo.ptcp.txt-Quality': 'Chất lượng',
  'algo.ptcp.txt-Introduction': 'Giới thiệu',
  'algo.ptcp.txt-Basic-information': 'Thông tin cơ bản',
  'algo.ptcp.txt-Subsidiaries': 'Công ty con',
  'algo.ptcp.txt-Associates': 'Công ty liên kết',
  'algo.ptcp.txt-Others': 'Khác',
  'algo.ptcp.txt-Peers': 'Công ty cùng ngành',
  'algo.ptcp.txt-Board-managers': 'Ban lãnh đạo',
  'algo.ptcp.txt-Large-shareholders': 'Cổ đông lớn',
  'algo.ptcp.txt-Listed-date': 'Ngày niêm yết',
  'algo.ptcp.txt-Listed-exchange': 'Nơi niêm yết',
  'algo.ptcp.txt-Listed-price': 'Giá chào sàn',
  'algo.ptcp.txt-Listed-shares': 'KL đang niêm yết',
  'algo.ptcp.txt-Market-capitalization': 'Thị giá vốn',
  'algo.ptcp.txt-Outstanding-shares': 'SLCP lưu hành',
  'algo.ptcp.txt-Sector-ICB': 'Ngành cấp {{name}}',
  'algo.ptcp.txt-Name': 'Tên Cty',
  'algo.ptcp.txt-Capital-bil': 'VĐL (Tỷ)',
  'algo.ptcp.txt-ownership': 'TL nắm giữ',
  'algo.ptcp.txt-Ticker': 'Mã',
  'algo.ptcp.txt-Price': 'Giá',
  'algo.ptcp.txt-vol': 'KLGD',
  'algo.ptcp.txt-Time': 'Thời gian',
  'algo.ptcp.txt-Title': 'Tiêu đề',
  'algo.ptcp.txt-Source': 'Nguồn tin',
  'algo.ptcp.txt-Events': 'Sự kiện',
  'algo.ptcp.txt-Insider-transactions': 'GD CĐ lớn và nội bộ',
  'algo.ptcp.txt-Announced-date': 'Ngày thông báo',
  'algo.ptcp.txt-Description': 'Tên sự kiện',
  'algo.ptcp.txt-Ex-date': 'Ngày GDKHQ',
  'algo.ptcp.txt-Last-register-date': 'Ngày đăng ký cuối',
  'algo.ptcp.txt-Effective-date': 'Ngày thực hiện',
  'algo.ptcp.txt-Trans-type': 'Giao dịch',
  'algo.ptcp.txt-Notifier': 'Người giao dịch',
  'algo.ptcp.txt-Position': 'Chức vụ',
  'algo.ptcp.txt-Related-person': 'Người liên quan',
  'algo.ptcp.txt-Relationship': 'Mối quan hệ',
  'algo.ptcp.txt-Reg-quantity': 'KL đăng ký',
  'algo.ptcp.txt-Real-quantity': 'KL đã thực hiện',
  'algo.ptcp.txt-Held-quantity': 'Sở hữu sau GD',
  'algo.ptcp.txt-Start-date': 'Ngày bắt đầu',
  'algo.ptcp.txt-End-date': 'Ngày kết thúc',
  'algo.ptcp.txt-Status': 'Trạng thái',

  'algo.ptcp.txt-Events-Detail': 'Chi tiết sự kiện',
  'algo.ptcp.txt-apendix-doc': 'Tài liệu đính kèm',

  'algo.lcp.txt-Filters': 'Bộ lọc',
  'algo.lcp.txt-Your-Filters': 'Bộ lọc của bạn',
  'algo.lcp.txt-Select-filter-condition': 'Chọn điều kiện lọc',
  'algo.lcp.txt-Select-criteria': 'Chọn tiêu chí',
  'algo.lcp.txt-Exchange': 'Sàn',
  'algo.lcp.txt-Industry': 'Ngành',
  'algo.lcp.txt-Input-value': 'Chọn giá trị',
  'algo.lcp.txt-Reload-result': 'Tải lại kết quả',
  'algo.lcp.txt-Clear-all': 'Xóa tất cả',
  'algo.lcp.txt-Result': 'Kết quả lọc',
  'algo.lcp.txt-Add-to-watchlist': 'Thêm vào danh mục',
  'algo.lcp.txt-Delete-watchlist': 'Xóa bộ lọc',
  'algo.lcp.txt-Save': 'Lưu bộ lọc',
  'algo.lcp.txt-Save-2': 'Lưu',
  'algo.lcp.txt-Save-new': 'Lưu bộ lọc mới',
  'algo.lcp.txt-Price-change-per-week': 'Giá thay đổi / tuần',
  'algo.lcp.txt-Price-change-per-month': 'Giá thay đổi / tháng',
  'algo.lcp.txt-del-bl-success': 'Xóa bộ lọc thành công!',
  'algo.lcp.txt-select-all': 'Chọn tất cả',

  'algo.cb.txt-Criteria': 'Tín hiệu',
  'algo.cb.txt-Manage-signals': 'Quản lý tín hiệu',
  'algo.cb.txt-Set-signals': 'Đặt tín hiệu',
  'algo.cb.txt-Trade-date': 'Ngày',
  'algo.cb.txt-Exchange': 'Sàn',
  'algo.cb.txt-Ticker': 'Mã',
  'algo.cb.txt-Name': 'Tên công ty',
  'algo.cb.txt-Market-cap': 'Vốn hóa',
  'algo.cb.txt-Price': 'Giá hiện tại',
  'algo.cb.txt-up-down': 'Tăng / Giảm',
  'algo.cb.txt-5-day-avg': 'TB KLGD 5 phiên',
  'algo.cb.txt-Signal': 'Tín hiệu',
  'algo.cb.txt-No-data': 'Không có dữ liệu',
  'algo.cb.txt-Criteria-2': 'Tín hiệu',
  'algo.cb.txt-Delete': 'Xóa',
  'algo.cb.txt-Edit': 'Sửa',
  'algo.cb.txt-Cancel': 'Hủy bỏ',
  'algo.cb.txt-Create-2': 'Tạo tín hiệu',
  'algo.cb.txt-View': 'Xem',
  'algo.cb.txt-Backtest-resul': 'Kết quả Backtest cho {{symbol}}',
  'algo.cb.txt-year': 'Năm',
  'algo.cb.txt-buy-signal': 'Tín hiệu mua',
  'algo.cb.txt-sell-signal': 'Tín hiệu bán',
  'algo.cb.txt-buy-order': 'Lệnh mua',
  'algo.cb.txt-sell-order': 'Lệnh bán',
  'algo.cb.txt-buy-gain': 'Lệnh lãi',
  'algo.cb.txt-buy-lost': 'Lệnh lỗ',
  'algo.cb.txt-stop-lost': 'Cắt lỗ',
  'algo.cb.txt-take-profit': 'Chốt lãi',

  'algo.industry.0001': 'Dầu khí',
  'algo.industry.1300': 'Hóa chất',
  'algo.industry.1700': 'Tài nguyên cơ bản',
  'algo.industry.2300': 'Xây dựng và vật liệu',
  'algo.industry.2700': 'Hàng & Dịch vụ Công nghiệp',
  'algo.industry.3300': 'Ô tô và phụ tùng',
  'algo.industry.3500': 'Thực phẩmm và đồ uống',
  'algo.industry.3700': 'Hàng cá nhân & Gia dụng',
  'algo.industry.5300': 'Bán lẻ',
  'algo.industry.5500': 'Truyền thông',
  'algo.industry.5700': 'Du lịch và giải trí',
  'algo.industry.6000': 'Viễn thông',
  'algo.industry.8300': 'Ngân hàng',
  'algo.industry.8500': 'Bảo hiểm',
  'algo.industry.8600': 'Bất động sản',
  'algo.industry.8700': 'Dịch vụ Tài chính',
  'algo.industry.9000': 'Công nghệ Thông tin',

  'algo.industry.0530': 'Sản xuất Dầu khí',
  'algo.industry.0570': 'Thiết bị, Dịch vụ và Phân phối Dầu khí',
  'algo.industry.1350': 'Hóa chất',
  'algo.industry.1730': 'Lâm nghiệp và Giấy',
  'algo.industry.1750': 'Kim loại',
  'algo.industry.1770': 'Khai khoáng',
  'algo.industry.2350': 'Xây dựng và Vật liệu',
  'algo.industry.2710': 'Hàng không & Quốc phòng',
  'algo.industry.2720': 'Hàng công nghiệp',
  'algo.industry.2730': 'Điện tử & Thiết bị điện',
  'algo.industry.2750': 'Công nghiệp nặng',
  'algo.industry.2770': 'Vận tải',
  'algo.industry.2790': 'Tư vấn & Hỗ trợ Kinh doanh',
  'algo.industry.3350': 'Ô tô và phụ tùng',
  'algo.industry.3530': 'Bia và đồ uống',
  'algo.industry.3570': 'Sản xuất thực phẩm',
  'algo.industry.3720': 'Hàng gia dụng',
  'algo.industry.3740': 'Hàng hóa giải trí',
  'algo.industry.3760': 'Hàng cá nhân',
  'algo.industry.3780': 'Thuốc lá',
  'algo.industry.4530': 'Thiết bị và Dịch vụ Y tế',
  'algo.industry.4570': 'Dược phẩm',
  'algo.industry.5330': 'Phân phối thực phẩm & dược phẩm',
  'algo.industry.5370': 'Bán lẻ',
  'algo.industry.5550': 'Truyền thông',
  'algo.industry.5750': 'Du lịch & Giải trí',
  'algo.industry.6530': 'Viễn thông cố định',
  'algo.industry.6570': 'Viễn thông di động',
  'algo.industry.7530': 'Điện',
  'algo.industry.7570': 'Nước & Khí đốt',
  'algo.industry.8350': 'Ngân hàng',
  'algo.industry.8530': 'Bảo hiểm phi nhân thọ',
  'algo.industry.8570': 'Bảo hiểm nhân thọ',
  'algo.industry.8630': 'Bất động sản',
  'algo.industry.8770': 'Dịch vụ tài chính',
  'algo.industry.8980': 'Quỹ đầu tư',
  'algo.industry.8990': 'Quỹ đầu tư mạo hiểm',
  'algo.industry.9530': 'Phần mềm & Dịch vụ Máy tính',
  'algo.industry.9570': 'Thiết bị và Phần cứng',

  'algo.chart.top-anh-huong':
    'Biểu đồ thể hiện thông tin điểm ảnh hưởng và % ảnh hưởng của 30 cổ phiếu tác động nhất tới tăng giảm điểm của Bộ chỉ số, trong đó 15 mã ảnh hưởng chiều tăng và 15 mã ảnh hưởng chiều giảm. Dữ liệu ngày: ',
  'algo.chart.kl-giao-dich':
    'Biểu đồ thể hiện khối lượng giao dịch của sàn đang tập trung vào những mã nào. Dữ liệu ngày: ',
  'algo.chart.bieu-do-von-hoa':
    'Biểu đồ cho thấy phân bổ vốn hóa của tất cả các mã trên sàn. Dữ liệu ngày: ',
  'algo.chart.thanh-khoan':
    'Biểu đồ so sánh dòng tiền tại cùng thời điểm với phiên trước, trung bình 1 tuần, 2 tuần và trung bình 1 tháng. Dữ liệu ngày: ',
  'algo.chart.kl-kn-mua-rong':
    'Màu xanh trên biểu đồ thể hiện khối ngoại mua ròng. Màu đỏ thể hiện khối ngoại bán ròng. Dữ liệu bao gồm Cổ phiếu và ETF. Dữ liệu ngày: ',
  'algo.chart.gt-kn-mua-rong':
    'Màu xanh trên biểu đồ thể hiện khối ngoại mua ròng. Màu đỏ thể hiện khối ngoại bán ròng. Dữ liệu bao gồm Cổ phiếu và ETF. Đơn vị giá trị là triệu VND. Dữ liệu ngày: ',
  'algo.chart.kl-td-mua-rong':
    'Màu xanh trên biểu đồ thể hiện khối tự doanh mua ròng. Màu đỏ thể hiện khối tự doanh bán ròng. Dữ liệu ngày: ',
  'algo.chart.gt-td-mua-rong':
    'Màu xanh trên biểu đồ thể hiện khối tự doanh mua ròng. Màu đỏ thể hiện khối tự doanh bán ròng. Đơn vị giá trị là triệu VND. Dữ liệu ngày: ',
  'algo.chart.top-nganh-index':
    'Biểu đồ thể hiện đóng góp của ngành vào INDEX. Dữ liệu ngày: ',
  'algo.chart.kn-mua-rong-theo-nganh':
    'Màu xanh trên biểu đồ thể hiện khối ngoại mua ròng. Màu đỏ thể hiện khối ngoại bán ròng. Dữ liệu bao gồm Cổ phiếu và ETF. Đơn vị giá trị là triệu VND. Dữ liệu ngày: ',
  'algo.chart.td-mua-rong-theo-nganh':
    'Màu xanh trên biểu đồ thể hiện khối tự doanh mua ròng. Màu đỏ thể hiện khối tự doanh bán ròng. Dữ liệu ngày: ',
  'algo.chart.gt-gd-theo-nganh':
    'Biểu đồ thể hiện giá trị giao dịch ngành (đơn vị Triệu VND). Màu xanh trên biểu đồ thể hiện ngành đóng góp dương (kéo INDEX lên), màu đỏ thể hiện đóng góp âm (kéo INDEX xuống). Dữ liệu ngày: ',
  'algo.chart.do-rong-thi-truong':
    'Biểu đồ thể hiện tỷ trọng các mã tăng giá, giảm giá và không đổi theo thời gian trong phiên.',
  'algo.chart.dong-tien-dong':
    'Biểu đồ thể hiện giá trị giao dịch mua chủ động ròng trong phiên.',

  'algo.bl.type.CO_TUC': 'Cổ tức',
  'algo.bl.type.DINH_GIA': 'Định giá',
  'algo.bl.type.GIA_KHOI_LUONG': 'Giá và khối lượng',
  'algo.bl.type.HIEU_QUA_HOAT_DONG': 'Hiệu quả hoạt động',
  'algo.bl.type.KHA_NANG_SINH_LOI': 'Khả năng sinh lời',
  'algo.bl.type.KHA_NANG_THANH_TOAN_DAI_HAN': 'Khả năng thanh toán dài hạn',
  'algo.bl.type.KHA_NANG_THANH_TOAN_NGAN_HAN': 'Khả năng thanh toán ngắn hạn',
  'algo.bl.type.KHOI_NGOAI': 'Khối ngoại',
  'algo.bl.type.QUY_MO': 'Quy mô',
  'algo.bl.type.SUC_KHOE_TAI_CHINH': 'Sức khỏe tài chính',
  'algo.bl.type.TANG_TRUONG': 'Tăng trưởng',
  'algo.bl.type.TIN_HIEU_KY_THUAT': 'Tín hiệu kỹ thuật',

  'algo.bl.CO_TUC.DVD_PAID_RATE': 'Tỷ lệ chi trả cổ tức (%)',
  'algo.bl.CO_TUC.DVD_PER_P': 'Tỷ suất cổ tức (%)',
  'algo.bl.CO_TUC.DVD_1Y': 'Cổ tức 4 quý (VND)',
  'algo.bl.CO_TUC.EPS': 'EPS 4 quý (VND)',

  'algo.bl.DINH_GIA.PE': 'PE (lần)',
  'algo.bl.DINH_GIA.PB': 'PB (lần)',
  'algo.bl.DINH_GIA.PS': 'PS (lần)',
  'algo.bl.DINH_GIA.EV_PER_EBIT': 'EV/EBIT (lần)',
  'algo.bl.DINH_GIA.EV_PER_EBITDA': 'EV/EBITDA (lần)',
  'algo.bl.DINH_GIA.P_PER_FCF': 'P/FCF (lần)',

  'algo.bl.GIA_KHOI_LUONG.VOL_PER_5D': 'KLGD so với TB KLGD 5 phiên (lần)',
  'algo.bl.GIA_KHOI_LUONG.VOL_PER_10D': 'KLGD so với TB KLGD 10 phiên (lần)',
  'algo.bl.GIA_KHOI_LUONG.VOL_PER_20D': 'KLGD so với TB KLGD 20 phiên (lần)',
  'algo.bl.GIA_KHOI_LUONG.VOL_10D_VS_3M':
    'TB KLGD 10 ngày so với TB KLGD 3 tháng (lần)',
  'algo.bl.GIA_KHOI_LUONG.VAL_PER_5D': 'GTGD so với TB GTGD 5 phiên (lần)',
  'algo.bl.GIA_KHOI_LUONG.VAL_PER_10D': 'GTGD so với TB GTGD 10 phiên (lần)',
  'algo.bl.GIA_KHOI_LUONG.VAL_PER_20D': 'GTGD so với TB GTGD 20 phiên (lần)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_20D': 'Giá so với MA 20 (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_50D': 'Giá so với MA 50 (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_130D': 'Giá so với MA 130 (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_200D': 'Giá so với MA 200 (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_1W': 'Thay đổi giá 1 tuần (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_1M': 'Thay đổi giá 1 tháng (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_3M': 'Thay đổi giá 3 tháng (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_6M': 'Thay đổi giá 6 tháng (%)',
  'algo.bl.GIA_KHOI_LUONG.P_CHANGE_1Y': 'Thay đổi giá 1 năm (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_MAX_52W': 'Giá so với giá cao 52 tuần (%)',
  'algo.bl.GIA_KHOI_LUONG.P_PER_MIN_52W': 'Giá so với giá thấp 52 tuần (%)',
  'algo.bl.GIA_KHOI_LUONG.BETA30D': 'Beta 30 ngày',
  'algo.bl.GIA_KHOI_LUONG.BETA60D': 'Beta 60 ngày',
  'algo.bl.GIA_KHOI_LUONG.BETA90D': 'Beta 90 ngày',
  'algo.bl.GIA_KHOI_LUONG.RS1W': 'Sức mạnh tương đương 1 tuần (%)',
  'algo.bl.GIA_KHOI_LUONG.RS1M': 'Sức mạnh tương đương 1 tháng (%)',
  'algo.bl.GIA_KHOI_LUONG.RS3M': 'Sức mạnh tương đương 3 tháng (%)',
  'algo.bl.GIA_KHOI_LUONG.RS6M': 'Sức mạnh tương đương 6 tháng (%)',
  'algo.bl.GIA_KHOI_LUONG.RS1Y': 'Sức mạnh tương đương 1 năm (%)',
  'algo.bl.GIA_KHOI_LUONG.STD_P_1Y': 'Độ lệch chuẩn theo ngày, 1 năm (%)',
  'algo.bl.GIA_KHOI_LUONG.TOTAL_VOL': 'KLGD hiện tại (CP)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_5D': 'TB KLGD 5 phiên (CP)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_10D': 'TB KLGD 10 phiên (CP)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_20D': 'TB KLGD 20 phiên (CP)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_30D': 'TB KLGD 30 phiên (CP)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_60D': 'TB KLGD 60 phiên (CP)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_YTD': 'TB KLGD YTD (CP)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VOL_1Y': 'TB KLGD 1 năm (CP)',
  'algo.bl.GIA_KHOI_LUONG.TOTAL_VAL': 'GTGD hiện tại (triệu VND)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_5D': 'TB GTGD 5 phiên (triệu VND)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_10D': 'TB GTGD 10 phiên (triệu VND)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_20D': 'TB GTGD 20 phiên (triệu VND)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_30D': 'TB GTGD 30 phiên (triệu VND)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_60D': 'TB GTGD 60 phiên (triệu VND)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_YTD': 'TB GTGD YTD (triệu VND)',
  'algo.bl.GIA_KHOI_LUONG.AVG_VAL_1Y': 'TB GTGD 1 năm (triệu VND)',

  'algo.bl.HIEU_QUA_HOAT_DONG.INVENTORY_TURN':
    'Hệ số quay vòng hàng tồn kho (lần)',
  'algo.bl.HIEU_QUA_HOAT_DONG.INVENTORY_DAYS':
    'Số ngày hàng tồn kho trong kỳ (ngày)',
  'algo.bl.HIEU_QUA_HOAT_DONG.REC_TURN': 'Hệ số quay vòng khoản phải thu (lần)',
  'algo.bl.HIEU_QUA_HOAT_DONG.REC_DAYS': 'Số ngày phải thu trong kỳ (ngày)',
  'algo.bl.HIEU_QUA_HOAT_DONG.PAY_TURN': 'Hệ số quay vòng khoản phải trả (lần)',
  'algo.bl.HIEU_QUA_HOAT_DONG.PAY_DAYS': 'Số ngày phải trả trong kỳ (ngày)',
  'algo.bl.HIEU_QUA_HOAT_DONG.CAPITAL_TURN':
    'Hệ số quay vòng vốn lưu động (lần)',
  'algo.bl.HIEU_QUA_HOAT_DONG.FIXED_ASSETS_TURN':
    'Hệ số quay vòng tài sản cố định (lần)',
  'algo.bl.HIEU_QUA_HOAT_DONG.ASSETS_TURN':
    'Hệ số quay vòng tổng tài sản (lần)',

  'algo.bl.KHA_NANG_SINH_LOI.ROA': 'ROA (%)',
  'algo.bl.KHA_NANG_SINH_LOI.ROE': 'ROE (%)',
  'algo.bl.KHA_NANG_SINH_LOI.GR_MARGIN': 'Biên lợi nhuận gộp (%)',
  'algo.bl.KHA_NANG_SINH_LOI.OPERATING_MARGIN': 'Biên lợi nhuận hoạt động (%)',
  'algo.bl.KHA_NANG_SINH_LOI.BF_TAX_MARGIN': 'Biên lợi nhuận trước thuế (%)',
  'algo.bl.KHA_NANG_SINH_LOI.NET_MARGIN': 'Biên lợi nhuận sau thuế (%)',
  'algo.bl.KHA_NANG_SINH_LOI.ROIC': 'ROIC (%)',
  'algo.bl.KHA_NANG_SINH_LOI.ROCE': 'ROCE (%)',

  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.DEBT_PER_ASSETS':
    'Chỉ số nợ trên tổng tài sản (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.DEBT_PER_CAPITAL':
    'Chỉ số nợ trên tổng nguồn vốn (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.DEBT_PER_EQUITY':
    'Chỉ số nợ trên vốn chủ sở hữu (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.LEVERAGE':
    'Chỉ số đòn bẩy tài chính (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.INT_COVERAGE':
    'Tỉ lệ đảm bảo chi phí lãi vay (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.CASH_PER_ASSETS':
    'Chỉ số tiền mặt trên tổng tài sản (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.FCF_PER_LT_DEBT':
    'Chỉ số FCF trên nợ dài hạn (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.NET_DEBT_PER_EQUITY':
    'Chỉ số nợ ròng trên vốn chủ sở hữu (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.NET_DEBT_PER_TANGIBLE_EQUITY':
    'Chỉ số nợ ròng trên vốn chủ sở hữu hữu hình (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.LT_DEBT_PER_ASSETS':
    'Chỉ số nợ dài hạn trên tổng tài sản (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.TANGIBLE_ASSETS_PER_EQUITY':
    'Chỉ số tài sản hữu hình trên vốn chủ sở hữu (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.NET_DEBT_PER_MC':
    'Chỉ số nợ ròng trên vốn hóa (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_DAI_HAN.NET_DEBT_PER_TANGIBLE_ASSETS':
    'Chỉ số nợ ròng trên tài sản hữu hình (lần)',

  'algo.bl.KHA_NANG_THANH_TOAN_NGAN_HAN.CURR_RATIO':
    'Chỉ số thanh toán ngắn hạn (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_NGAN_HAN.QUICK_RATIO':
    'Chỉ số thanh toán nhanh (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_NGAN_HAN.CASH_RATIO':
    'Chỉ số thanh toán tiền mặt (lần)',
  'algo.bl.KHA_NANG_THANH_TOAN_NGAN_HAN.CASH_TURN': 'Vòng quay tiền mặt (ngày)',

  'algo.bl.KHOI_NGOAI.F_BUY_VALUE': 'GT mua khối ngoại (triệu VND)',
  'algo.bl.KHOI_NGOAI.F_SELL_VALUE': 'GT bán khối ngoại (triệu VND)',
  'algo.bl.KHOI_NGOAI.F_NET_BUY_VALUE': 'GT mua ròng khối ngoại (triệu VND)',
  'algo.bl.KHOI_NGOAI.F_BUY_VAL_PER_5D':
    'GT mua khối ngoại so với TB 5 phiên trước (lần)',
  'algo.bl.KHOI_NGOAI.F_BUY_VAL_PER_10D':
    'GT mua khối ngoại so với TB 10 phiên trước (lần)',
  'algo.bl.KHOI_NGOAI.F_BUY_VAL_PER_20D':
    'GT mua khối ngoại so với TB 20 phiên trước (lần)',
  'algo.bl.KHOI_NGOAI.F_SELL_VAL_PER_5D':
    'GT bán khối ngoại so với TB 5 phiên trước (lần)',
  'algo.bl.KHOI_NGOAI.F_SELL_VAL_PER_10D':
    'GT bán khối ngoại so với TB 10 phiên trước (lần)',
  'algo.bl.KHOI_NGOAI.F_SELL_VAL_PER_20D':
    'GT bán khối ngoại so với TB 20 phiên trước (lần)',
  'algo.bl.KHOI_NGOAI.F_NET_BUY_VOLUME': 'KL mua ròng khối ngoại (CP)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_5D':
    'KL mua ròng khối ngoại TB 5 phiên (CP)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_10D':
    'KL mua ròng khối ngoại TB 10 phiên (CP)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_20D':
    'KL mua ròng khối ngoại TB 20 phiên (CP)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_30D':
    'KL mua ròng khối ngoại TB 30 phiên (CP)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_60D':
    'KL mua ròng khối ngoại TB 60 phiên (CP)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_YTD':
    'KL mua ròng khối ngoại TB YTD (CP)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_VOL_1Y':
    'KL mua ròng khối ngoại TB 1 năm (CP)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_5D':
    'GT mua ròng khối ngoại TB 5 phiên (triệu VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_10D':
    'GT mua ròng khối ngoại TB 10 phiên (triệu VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_20D':
    'GT mua ròng khối ngoại TB 20 phiên (triệu VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_30D':
    'GT mua ròng khối ngoại TB 30 phiên (triệu VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_60D':
    'GT mua ròng khối ngoại TB 60 phiên (triệu VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_YTD':
    'GT mua ròng khối ngoại TB YTD (triệu VND)',
  'algo.bl.KHOI_NGOAI.AVG_F_NET_BUY_1Y':
    'GT mua ròng khối ngoại TB 1 năm (triệu VND)',

  'algo.bl.QUY_MO.MC': 'Vốn hóa (tỷ VND)',
  'algo.bl.QUY_MO.EV': 'EV (tỷ VND)',

  'algo.bl.SUC_KHOE_TAI_CHINH.M_SCORE': 'M-Score',
  'algo.bl.SUC_KHOE_TAI_CHINH.F_SCORE': 'F-Score',
  'algo.bl.SUC_KHOE_TAI_CHINH.Z_SCORE': 'Z-Score',
  'algo.bl.SUC_KHOE_TAI_CHINH.C_SCORE': 'C-Score',
  'algo.bl.SUC_KHOE_TAI_CHINH.MAGIC_SCORE': 'Magic Formula Score',

  'algo.bl.TANG_TRUONG.NET_INC_GROWTH':
    'Tăng trưởng LN ròng 4 quý gần nhất so với 4 quý trước (%)',
  'algo.bl.TANG_TRUONG.EPS_GROWTH':
    'Tăng trưởng EPS 4 quý gần nhất so với 4 quý trước (%)',
  'algo.bl.TANG_TRUONG.REV_GROWTH_1Y':
    'Tăng trưởng doanh thu 4 quý gần nhất so với 4 quý trước (%)',
  'algo.bl.TANG_TRUONG.DVD_GROWTH':
    'Tăng trưởng DPS 4 quý gần nhất so với 4 quý trước (%)',
  'algo.bl.TANG_TRUONG.OPERATING_INC_GROWTH':
    'Tăng trưởng LN từ HĐKD 4 quý gần nhất so với 4 quý trước (%)',
  'algo.bl.TANG_TRUONG.GR_PROFIT_GROWTH':
    'Tăng trưởng LN gộp 4 quý gần nhất so với 4 quý trước (%)',
  'algo.bl.TANG_TRUONG.NET_INC_GROWTH1':
    'Tăng trưởng LN ròng quý gần nhất so với quý cùng kỳ năm trước (%)',
  'algo.bl.TANG_TRUONG.REV_GROWTH1':
    'Tăng trưởng doanh thu quý gần nhất so với quý cùng kỳ năm trước (%)',
  'algo.bl.TANG_TRUONG.OPERATING_INC_GROWTH1':
    'Tăng trưởng LN từ HĐKD quý gần nhất so với quý cùng kỳ năm trước (%)',
  'algo.bl.TANG_TRUONG.GR_PROFIT_GROWTH1':
    'Tăng trưởng LN gộp quý gần nhất so với quý cùng kỳ năm trước (%)',

  'algo.bl.TIN_HIEU_KY_THUAT.RSI_14': 'RSI (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.STOCHASTIC_14_3_3': 'STOCH (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.ADI_14': 'ADX (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.STOCHASTIC_RSI_14': 'STOCHRSI (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.ATR_14': 'ATR (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.WILLIAMR_14': 'William %R (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.MACD_12_26_9': 'MACD (12,26,9)',
  'algo.bl.TIN_HIEU_KY_THUAT.MFI_14': 'MFI (14)',
  'algo.bl.TIN_HIEU_KY_THUAT.BBAND_20_2': 'Bollinger Band %B (20,2)',
  'algo.bl.TIN_HIEU_KY_THUAT.MA_ENVELOPES_20_25':
    'Moving Average Envelopes (20,2.5) %E',
  'algo.bl.TIN_HIEU_KY_THUAT.P_PER_SMA10': 'Giá so với SMA (10) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.P_PER_EMA10': 'Giá so với EMA (10) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.P_PER_DEMA10': 'Giá so với DEMA (10) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.P_PER_WMA10': 'Giá so với WMA (10) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.SMA5_PER_SMA20': 'SMA (5) so với SMA (20) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.EMA5_PER_EMA20': 'EMA (5) so với EMA (20) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.DEMA5_PER_DEMA20': 'DEMA (5) so với DEMA (20) (%)',
  'algo.bl.TIN_HIEU_KY_THUAT.WMA5_PER_WMA20': 'WMA (5) so với WMA (20) (%)',

  'algo.signal.1133': 'ADX(14)',
  'algo.signal.1134': 'Bollinger Band(20,2)',
  'algo.signal.1135': 'CCI(14)',
  'algo.signal.1137': 'Giá so với đường EMA(20)',
  'algo.signal.1138': 'Giá so với đường EMA(50)',
  'algo.signal.1139': 'Giá so với đường SMA(20)',
  'algo.signal.1140': 'Giá so với đường SMA(50)',
  'algo.signal.1141': 'Giá so với đỉnh đáy 3 tháng',
  'algo.signal.1142': 'Giá so với đỉnh đáy 6 tháng',
  'algo.signal.1143': 'MACD(12,26,9)',
  'algo.signal.1144': 'MFI(14)',
  'algo.signal.1145': 'RSI(14)',
  'algo.signal.1146': 'StochRSI(14)',
  'algo.signal.1147': 'Stochastic(9,6,6)',
  'algo.signal.1148': 'William %R(14)',
  'algo.signal.1149': 'Đường EMA(20) so với đường EMA(50)',
  'algo.signal.1150': 'Đường EMA(5) so với đường EMA(20)',
  'algo.signal.1151': 'Đường SMA(20) so với đường SMA(50)',
  'algo.signal.1152': 'Đường SMA(5) so với đường SMA(20)',

  'algo.tooltip.1133':
    'Mua khi ADX > 20 và +DI cắt lên -DI\nBán khi ADX < 20 và +DI cắt xuống -DI',
  'algo.tooltip.1134':
    'Mua khi Giá hiện tại cắt xuống Band dưới\nBán khi Giá hiện tại cắt lên Band trên',
  'algo.tooltip.1135':
    'Mua khi CCI cắt lên đường -200\nBán khi CCI cắt xuống đường 200',
  'algo.tooltip.1137':
    'Mua khi giá hiện tại cắt lên đường EMA(20)\nBán khi giá hiện tại cắt xuống đường EMA(20)',
  'algo.tooltip.1138':
    'Mua khi giá hiện tại cắt lên đường EMA(50)\nBán khi giá hiện tại cắt xuống đường EMA(50)',
  'algo.tooltip.1139':
    'Mua khi giá hiện tại cắt lên đường SMA(20)\nBán khi giá hiện tại cắt xuống đường SMA(20)',
  'algo.tooltip.1140':
    'Mua khi giá hiện tại cắt lên đường SMA(50)\nBán khi giá hiện tại cắt xuống đường SMA(50)',
  'algo.tooltip.1141':
    'Mua khi giá hiện tại vượt đỉnh 3 tháng\nBán khi giá hiện tại thủng đáy 3 tháng',
  'algo.tooltip.1142':
    'Mua khi giá hiện tại vượt đỉnh 6 tháng\nBán khi giá hiện tại thủng đáy 6 tháng',
  'algo.tooltip.1143':
    'Mua khi MACD cắt lên đường 0\nBán khi MACD cắt xuống đường 0',
  'algo.tooltip.1144': 'Mua khi MFI < 10\nBán khi MFI > 90',
  'algo.tooltip.1145':
    'Mua khi RSI(14) cắt xuống đường 30\nBán khi RSI(14) cắt lên đường 70',
  'algo.tooltip.1146':
    'Mua khi StochRSI(14) cắt xuống đường 10\nBán khi StochRSI(14) cắt lên đường 90',
  'algo.tooltip.1147':
    'Mua khi Stochastic cắt lên đường 20\nBán khi Stochastic cắt xuống đường 80',
  'algo.tooltip.1148':
    'Mua khi %R cắt xuống đường -80\nBán khi %R cắt lên đường -20',
  'algo.tooltip.1149':
    'Mua khi đường EMA(20) cắt lên đường EMA(50)\nBán khi đường EMA(20) cắt xuống đường EMA(50)',
  'algo.tooltip.1150':
    'Mua khi đường EMA(5) cắt lên đường EMA(20)\nBán khi đường EMA(5) cắt xuống đường EMA(20)',
  'algo.tooltip.1151':
    'Mua khi đường SMA(20) cắt lên đường SMA(50)\nBán khi đường SMA(20) cắt xuống đường SMA(50)',
  'algo.tooltip.1152':
    'Mua khi đường SMA(5) cắt lên đường SMA(20)\nBán khi đường SMA(5) cắt xuống đường SMA(20)',

  'algo.tooltip.DVD_PAID_RATE':
    'Được tính bằng DPS 4 quý gần nhất chia cho EPS 4 quý gần nhất.\nDPS là cổ tức trên mỗi cổ phiếu.\nEPS là lợi nhuận ròng trên mỗi cổ phiếu.',
  'algo.tooltip.DVD_PER_P':
    'Được tính bằng DPS 4 quý gần nhất chia cho Giá đóng cửa phiên gần nhất.\nDPS là cổ tức trên mỗi cổ phiếu.',
  'algo.tooltip.DVD_1Y':
    'Tổng cổ tức tiền mặt trên 1 cổ phiếu trong 4 quý gần nhất',
  'algo.tooltip.EPS':
    'Được tính bằng Lợi nhuận sau thuế của công ty mẹ 4 quý gần nhất chia cho Bình quân số lượng cổ phiếu đang lưu hành 4 quý tương ứng.',
  'algo.tooltip.PE':
    'Được tính bằng Vốn hóa chia cho Lợi nhuận sau thuế của công ty mẹ 4 quý gần nhất.',
  'algo.tooltip.PB':
    'Được tính bằng Vốn hóa chia cho Giá trị sổ sách quý gần nhất.',
  'algo.tooltip.PS':
    'Được tính bằng Vốn hóa chia cho Doanh thu 4 quý gần nhất.',
  'algo.tooltip.EV_PER_EBIT':
    'Được tính bằng EV chia cho EBIT.\nCách tính EV được trình bày trong phần chỉ số của nhóm Quy mô.\nEBIT được tính bằng (Doanh thu thuần 4 quý gần nhất – Giá vốn hàng bán 4 quý gần nhất – Chi phí bán hàng và quản lý doanh nghiệp 4 quý gần nhất).\nChỉ tiêu này không được tính cho nhóm ngân hàng và bảo hiểm.',
  'algo.tooltip.EV_PER_EBITDA':
    'Được tính bằng EV chia cho EBITDA.\nCách tính EV được trình bày trong phần chỉ số của nhóm Quy mô.\nEBITDA được tính bằng (Doanh thu thuần 4 quý gần nhất – Giá vốn hàng bán 4 quý gần nhất – Chi phí bán hàng và quản lý doanh nghiệp 4 quý gần nhất + Chi phí khấu hao 4 quý gần nhất).\nChỉ tiêu này không được tính cho nhóm ngân hàng và bảo hiểm.',
  'algo.tooltip.P_PER_FCF':
    'Được tính bằng Vốn hóa chia cho FCF 4 quý gần nhất.\nFCF = Dòng tiền từ hoạt động kinh doanh 4 quý gần nhất - (Tiền mua tài sản cố định và các tài sản khác 4 quý gần nhất - Tiền thu được từ thanh lý tài sản cố định 4 quý gần nhất) + Chi phí lãi vay 4 quý gần nhất * (1 – Thuế suất thuế TNDN)\nThuế suất thuế TNDN = Thuế TNDN 4 quý gần nhất / Lợi nhuận trước thuế 4 quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.TOTAL_VOL': 'Khối lượng giao dịch ngày giao dịch hiện tại',
  'algo.tooltip.AVG_VOL_5D':
    'Trung bình khối lượng giao dịch 5 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VOL_10D':
    'Trung bình khối lượng giao dịch 10 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VOL_20D':
    'Trung bình khối lượng giao dịch 20 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VOL_30D':
    'Trung bình khối lượng giao dịch 30 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VOL_60D':
    'Trung bình khối lượng giao dịch 60 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VOL_YTD':
    'Trung bình khối lượng giao dịch từ đầu năm tới hiện tại',
  'algo.tooltip.AVG_VOL_1Y': 'Trung bình khối lượng giao dịch 1 năm gần nhất',
  'algo.tooltip.TOTAL_VAL': 'Giá trị giao dịch ngày giao dịch hiện tại',
  'algo.tooltip.AVG_VAL_5D':
    'Trung bình giá trị giao dịch 5 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VAL_10D':
    'Trung bình giá trị giao dịch 10 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VAL_20D':
    'Trung bình giá trị giao dịch 20 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VAL_30D':
    'Trung bình giá trị giao dịch 30 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VAL_60D':
    'Trung bình giá trị giao dịch 60 ngày giao dịch gần nhất',
  'algo.tooltip.AVG_VAL_YTD':
    'Trung bình giá trị giao dịch từ đầu năm tới hiện tại',
  'algo.tooltip.AVG_VAL_1Y': 'Trung bình giá trị giao dịch 1 năm gần nhất',
  'algo.tooltip.VOL_PER_5D':
    'Được tính bằng khối lượng giao dịch ngày hôm nay chia cho bình quân khối lượng giao dịch 5 ngày giao dịch trước đó.',
  'algo.tooltip.VOL_PER_10D':
    'Được tính bằng khối lượng giao dịch ngày hôm nay chia cho bình quân khối lượng giao dịch 10 ngày giao dịch trước đó.',
  'algo.tooltip.VOL_PER_20D':
    'Được tính bằng khối lượng giao dịch ngày hôm nay chia cho bình quân khối lượng giao dịch 20 ngày giao dịch trước đó.',
  'algo.tooltip.VOL_10D_VS_3M':
    'Được tính bằng bình quân khối lượng giao dịch 10 ngày giao dịch gần nhất chia cho bình quân khối lượng giao dịch 3 tháng gần nhất.',
  'algo.tooltip.VAL_PER_5D':
    'Được tính bằng giá trị giao dịch ngày hôm nay chia cho bình quân giá trị giao dịch 5 ngày giao dịch trước đó.',
  'algo.tooltip.VAL_PER_10D':
    'Được tính bằng giá trị giao dịch ngày hôm nay chia cho bình quân giá trị giao dịch 10 ngày giao dịch trước đó.',
  'algo.tooltip.VAL_PER_20D':
    'Được tính bằng giá trị giao dịch ngày hôm nay chia cho bình quân giá trị giao dịch 20 ngày giao dịch trước đó.',
  'algo.tooltip.P_PER_20D':
    'Được tính bằng giá đóng cửa ngày hôm nay chia cho bình quân giá đóng cửa 20 ngày giao dịch trước đó.\nGiá điều chỉnh được sử dụng cho việc tính toán.',
  'algo.tooltip.P_PER_50D':
    'Được tính bằng giá đóng cửa ngày hôm nay chia cho bình quân giá đóng cửa 50 ngày giao dịch trước đó.\nGiá điều chỉnh được sử dụng cho việc tính toán.',
  'algo.tooltip.P_PER_130D':
    'Được tính bằng giá đóng cửa ngày hôm nay chia cho bình quân giá đóng cửa 130 ngày giao dịch trước đó.\nGiá điều chỉnh được sử dụng cho việc tính toán.',
  'algo.tooltip.P_PER_200D':
    'Được tính bằng giá đóng cửa ngày hôm nay chia cho bình quân giá đóng cửa 200 ngày giao dịch trước đó.\nGiá điều chỉnh được sử dụng cho việc tính toán.',
  'algo.tooltip.P_CHANGE_1W':
    'Được tính bằng (Giá đóng cửa hôm nay / Giá đóng cửa 6 ngày giao dịch trước - 1)\nGiá điều chỉnh được sử dụng cho việc tính toán.',
  'algo.tooltip.P_CHANGE_1M':
    'Được tính bằng (Giá đóng cửa hôm nay / Giá đóng cửa ngày này tháng trước theo lịch - 1)\nGiá điều chỉnh được sử dụng cho việc tính toán.\nTrường hợp ngày này tháng trước là ngày nghỉ/ngày lễ thì sẽ lấy theo giá đóng cửa của ngày giao dịch gần nhất trước đó.',
  'algo.tooltip.P_CHANGE_3M':
    'Được tính bằng (Giá đóng cửa hôm nay / Giá đóng cửa ngày này 3 tháng trước theo lịch - 1).\nGiá điều chỉnh được sử dụng cho việc tính toán.\nTrường hợp ngày này tháng trước là ngày nghỉ/ngày lễ thì sẽ lấy theo giá đóng cửa của ngày giao dịch gần nhất trước đó.',
  'algo.tooltip.P_CHANGE_6M':
    'Được tính bằng (Giá đóng cửa hôm nay / Giá đóng cửa ngày này 6 tháng trước theo lịch - 1).\nGiá điều chỉnh được sử dụng cho việc tính toán.\nTrường hợp ngày này tháng trước là ngày nghỉ/ngày lễ thì sẽ lấy theo giá đóng cửa của ngày giao dịch gần nhất trước đó.',
  'algo.tooltip.P_CHANGE_1Y':
    'Được tính bằng (Giá đóng cửa hôm nay / Giá đóng cửa ngày này năm trước theo lịch - 1).\nGiá điều chỉnh được sử dụng cho việc tính toán.\nTrường hợp ngày này tháng trước là ngày nghỉ/ngày lễ thì sẽ lấy theo giá đóng cửa của ngày giao dịch gần nhất trước đó.',
  'algo.tooltip.P_PER_MAX_52W':
    'Được tính bằng (Giá đóng cửa hôm nay / Giá cao cao nhất 52 tuần).\nGiá điều chỉnh được sử dụng cho việc tính toán.',
  'algo.tooltip.P_PER_MIN_52W':
    'Được tính bằng (Giá đóng cửa hôm nay / Giá thấp thấp nhất 52 tuần).\nGiá điều chỉnh được sử dụng cho việc tính toán.',
  'algo.tooltip.BETA30D':
    'Beta 30 ngày = Covariance(Ri,Rm) / Variance(Rm)\nvới Ri là thay đổi giá cổ phiếu 1 ngày và Rm là thay đổi chỉ số VN-Index 1 ngày.\nGiá điều chỉnh được sử dụng cho việc tính toán và khoảng thời gian tính toán là 30 ngày giao dịch.',
  'algo.tooltip.BETA60D':
    'Beta 60 ngày = Covariance(Ri,Rm) / Variance(Rm)\nvới Ri là thay đổi giá cổ phiếu 1 ngày và Rm là thay đổi chỉ số VN-Index 1 ngày.\nGiá điều chỉnh được sử dụng cho việc tính toán và khoảng thời gian tính toán là 60 ngày giao dịch.',
  'algo.tooltip.BETA90D':
    'Beta 90 ngày = Covariance(Ri,Rm) / Variance(Rm)\nvới Ri là thay đổi giá cổ phiếu 1 ngày và Rm là thay đổi chỉ số VN-Index 1 ngày.\nGiá điều chỉnh được sử dụng cho việc tính toán và khoảng thời gian tính toán là 90 ngày giao dịch.',
  'algo.tooltip.RS1W':
    'Được tính bằng ((1 + Thay đổi giá cổ phiếu 1 tuần) / (1 + Thay đổi giá VN-Index 1 tuần) - 1)',
  'algo.tooltip.RS1M':
    'Được tính bằng ((1 + Thay đổi giá cổ phiếu 1 tháng) / (1 + Thay đổi giá VN-Index 1 tháng) - 1)',
  'algo.tooltip.RS3M':
    'Được tính bằng ((1 + Thay đổi giá cổ phiếu 3 tháng) / (1 + Thay đổi giá VN-Index 3 tháng) - 1)',
  'algo.tooltip.RS6M':
    'Được tính bằng ((1 + Thay đổi giá cổ phiếu 6 tháng) / (1 + Thay đổi giá VN-Index 6 tháng) - 1)',
  'algo.tooltip.RS1Y':
    'Được tính bằng ((1 + Thay đổi giá cổ phiếu 1 năm) / (1 + Thay đổi giá VN-Index 1 năm) - 1)',
  'algo.tooltip.STD_P_1Y':
    'Là chỉ tiêu đo độ phân tán của sự thay đổi giá cổ phiếu 1 ngày trong vòng 1 năm.',
  'algo.tooltip.INVENTORY_TURN':
    'Được tính bằng Giá vốn hàng bán 4 quý gần nhất chia cho bình quân Hàng tồn kho 4 quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.INVENTORY_DAYS':
    'Được tính bằng 365 chia cho Hệ số quay vòng hàng tồn kho.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.REC_TURN':
    'Được tính bằng Doanh thu thuần 4 quý gần nhất chia cho bình quân Khoản phải thu 4 quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.REC_DAYS':
    'Được tính bằng 365 chia cho Hệ số quay vòng khoản phải thu.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.PAY_TURN':
    'Được tính bằng Khoản mua vào chia cho bình quân Khoản phải trả.\nKhoản mua vào = Hàng tồn kho cuối kỳ - Hàng tồn kho đầu kỳ + Giá vốn hàng bán.\nCác chỉ tiêu được lấy 4 quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.PAY_DAYS':
    'Được tính bằng 365 chia cho Hệ số quay vòng khoản phải trả.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.CAPITAL_TURN':
    'Được tính bằng Doanh thu thuần chia cho bình quân Vốn lưu động.\nVốn lưu động = Tài sản ngắn hạn - Nợ ngắn hạn.\nCác chỉ tiêu được lấy 4 quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm',
  'algo.tooltip.FIXED_ASSETS_TURN':
    'Được tính bằng Doanh thu thuần 4 quý gần nhất chia cho bình quân Tài sản cố định 4 quý gần nhất.',
  'algo.tooltip.ASSETS_TURN':
    'Được tính bằng Doanh thu thuần 4 quý gần nhất chia cho bình quân Tổng tài sản 4 quý gần nhất.',
  'algo.tooltip.ROA':
    'Được tính bằng Lợi nhuận sau thuế 4 quý gần nhất chia cho bình quân Tổng tài sản 4 quý gần nhất.',
  'algo.tooltip.ROE':
    'Được tính bằng Lợi nhuận sau thuế 4 quý gần nhất chia cho bình quân Vốn chủ sở hữu 4 quý gần nhất.',
  'algo.tooltip.GR_MARGIN':
    'Được tính bằng Lợi nhuận gộp 4 quý gần nhất chia cho Doanh thu thuần 4 quý gần nhất.',
  'algo.tooltip.OPERATING_MARGIN':
    'Được tính bằng Lãi/(lỗ) từ hoạt động kinh doanh chia cho Doanh thu thuần 4 quý gần nhất.',
  'algo.tooltip.BF_TAX_MARGIN':
    'Được tính bằng Lợi nhuận trước thuế 4 quý gần nhất chia cho Doanh thu thuần 4 quý gần nhất.',
  'algo.tooltip.NET_MARGIN':
    'Được tính bằng Lợi nhuận sau thuế 4 quý gần nhất chia cho Doanh thu thuần 4 quý gần nhất.',
  'algo.tooltip.ROIC':
    'Được tính bằng EBIT 4 quý gần nhất * (1 – Thuế suất thuế TNDN) / (Bình quân Tổng tài sản 4 quý gần nhất - Bình quân Nợ ngắn hạn 4 quý gần nhất)\nEBIT 4 quý gần nhất = Doanh thu thuần 4 quý gần nhất – Giá vốn hàng bán 4 quý gần nhất – Chi phí bán hàng và quản lý doanh nghiệp 4 quý gần nhất.\nThuế suất thuế TNDN = Thuế TNDN 4 quý gần nhất / Lợi nhuận trước thuế 4 quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.ROCE':
    'Được tính bằng EBIT 4 quý gần nhất / (Bình quân Tổng tài sản 4 quý gần nhất - Bình quân Nợ ngắn hạn 4 quý gần nhất)\nEBIT 4 quý gần nhất = Doanh thu thuần 4 quý gần nhất – Giá vốn hàng bán 4 quý gần nhất – Chi phí bán hàng và quản lý doanh nghiệp 4 quý gần nhất\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.DEBT_PER_ASSETS':
    'Được tính bằng Tổng nợ chia cho Tổng tài sản.\nTổng nợ = Nợ ngắn hạn chịu lãi + Nợ dài hạn chịu lãi.\nCác chỉ tiêu được lấy theo quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng.',
  'algo.tooltip.DEBT_PER_CAPITAL':
    'Được tính bằng Tổng nợ chia cho Tổng nguồn vốn.\nTổng nợ = Nợ ngắn hạn chịu lãi + Nợ dài hạn chịu lãi.\nTổng nguồn vốn = Vốn chủ sở hữu + Tổng nợ.\nCác chỉ tiêu được lấy theo quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng.',
  'algo.tooltip.DEBT_PER_EQUITY':
    'Được tính bằng Tổng nợ chia cho Vốn chủ sở hữu.\nTổng nợ = Nợ ngắn hạn chịu lãi + Nợ dài hạn chịu lãi. \nCác chỉ tiêu được lấy theo quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng.',
  'algo.tooltip.LEVERAGE':
    'Được tính bằng Tổng tài sản quý gần nhất chia cho Vốn chủ sở hữu quý gần nhất.',
  'algo.tooltip.INT_COVERAGE':
    'Được tính bằng EBIT 4 quý gần nhất chia cho Chi phí lãi vay 4 quý gần nhất.\nEBIT 4 quý gần nhất = Doanh thu thuần 4 quý gần nhất – Giá vốn hàng bán 4 quý gần nhất – Chi phí bán hàng và quản lý doanh nghiệp 4 quý gần nhất\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.CASH_PER_ASSETS':
    'Được tính bằng Tiền và tương đương tiền quý gần nhất chia cho Tổng tài sản quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng.',
  'algo.tooltip.FCF_PER_LT_DEBT':
    'Được tính bằng FCF 4 quý gần nhất chia cho Nợ dài hạn quý gần nhất.\nFCF = Dòng tiền từ hoạt động kinh doanh 4 quý gần nhất - (Tiền mua tài sản cố định và các tài sản khác 4 quý gần nhất - Tiền thu được từ thanh lý tài sản cố định 4 quý gần nhất) + Chi phí lãi vay 4 quý gần nhất * (1 – Thuế suất thuế TNDN)\nThuế suất thuế TNDN = Thuế TNDN 4 quý gần nhất / Lợi nhuận trước thuế 4 quý gần nhất\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.NET_DEBT_PER_EQUITY':
    'Được tính bằng Nợ ròng chia cho Vốn chủ sở hữu.\nNợ ròng = Nợ ngắn hạn chịu lãi + Nợ dài hạn chịu lãi - Tiền và tương đương tiền - Giá trị thuần đầu tư ngắn hạn.\nCác chỉ tiêu được lấy theo quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.NET_DEBT_PER_TANGIBLE_EQUITY':
    'Được tính bằng Nợ ròng chia cho Vốn chủ sở hữu hữu hình.\nNợ ròng = Nợ ngắn hạn chịu lãi + Nợ dài hạn chịu lãi - Tiền và tương đương tiền - Giá trị thuần đầu tư ngắn hạn.\nVốn chủ sở hữu hữu hình = Vốn chủ sở hữu - Tài sản cố định vô hình.\nCác chỉ tiêu được lấy theo quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.LT_DEBT_PER_ASSETS':
    'Được tính bằng Nợ dài hạn quý gần nhất chia cho Tổng tài sản quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng.',
  'algo.tooltip.TANGIBLE_ASSETS_PER_EQUITY':
    'Được tính bằng Tài sản hữu hình chia cho Vốn chủ sở hữu.\nTài sản hữu hình = Tổng tài sản - Tài sản cố định vô hình.\nCác chỉ tiêu được lấy theo quý gần nhất.',
  'algo.tooltip.NET_DEBT_PER_MC':
    'Được tính bằng Nợ ròng chia cho Vốn hóa.\nNợ ròng = Nợ ngắn hạn chịu lãi + Nợ dài hạn chịu lãi - Tiền và tương đương tiền - Giá trị thuần đầu tư ngắn hạn.\nCác chỉ tiêu được lấy theo quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.NET_DEBT_PER_TANGIBLE_ASSETS':
    'Được tính bằng Nợ ròng chia cho Tài sản hữu hình.\nNợ ròng = Nợ ngắn hạn chịu lãi + Nợ dài hạn chịu lãi - Tiền và tương đương tiền - Giá trị thuần đầu tư ngắn hạn.\nTài sản hữu hình = Tổng tài sản - Tài sản cố định vô hình.\nCác chỉ tiêu được lấy theo quý gần nhất.\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.CURR_RATIO':
    'Được tính bằng Tài sản ngắn hạn quý gần nhất chia cho Nợ ngắn hạn quý gần nhất.',
  'algo.tooltip.QUICK_RATIO':
    'Được tính bằng ((Tiền và các khoản tương đương tiền + Giá trị thuần đầu tư ngắn hạn + Các khoản phải thu) / Nợ ngắn hạn). Các chỉ tiêu được lấy ở quý gần nhất.',
  'algo.tooltip.CASH_RATIO':
    'Được tính bằng ((Tiền và các khoản tương đương tiền + Giá trị thuần đầu tư ngắn hạn) / Nợ ngắn hạn). Các chỉ tiêu được lấy ở quý gần nhất.',
  'algo.tooltip.CASH_TURN':
    'Được tính bằng (Số ngày phải thu 4 quý gần nhất + Số ngày hàng tồn kho 4 quý gần nhất - Số ngày phải trả 4 quý gần nhất).',
  'algo.tooltip.F_BUY_VALUE': 'Giá trị khối ngoại mua vào của ngày hôm nay.',
  'algo.tooltip.F_SELL_VALUE': 'Giá trị khối ngoại bán ra của ngày hôm nay.',
  'algo.tooltip.F_NET_BUY_VALUE':
    'Được tính bằng giá trị khối ngoại mua vào trừ giá trị khối ngoại bán ra của ngày hôm nay.',
  'algo.tooltip.F_BUY_VAL_PER_5D':
    'Được tính bằng giá trị khối ngoại mua của ngày hôm nay chia cho bình quân giá trị khối ngoại mua vào 5 ngày giao dịch trước đó.',
  'algo.tooltip.F_BUY_VAL_PER_10D':
    'Được tính bằng giá trị khối ngoại mua của ngày hôm nay chia cho bình quân giá trị khối ngoại mua vào 10 ngày giao dịch trước đó.',
  'algo.tooltip.F_BUY_VAL_PER_20D':
    'Được tính bằng giá trị khối ngoại mua của ngày hôm nay chia cho bình quân giá trị khối ngoại mua vào 20 ngày giao dịch trước đó.',
  'algo.tooltip.F_SELL_VAL_PER_5D':
    'Được tính bằng giá trị khối ngoại bán của ngày hôm nay chia cho bình quân giá trị khối ngoại bán ra 5 ngày giao dịch trước đó.',
  'algo.tooltip.F_SELL_VAL_PER_10D':
    'Được tính bằng giá trị khối ngoại bán của ngày hôm nay chia cho bình quân giá trị khối ngoại bán ra 10 ngày giao dịch trước đó.',
  'algo.tooltip.F_SELL_VAL_PER_20D':
    'Được tính bằng giá trị khối ngoại bán của ngày hôm nay chia cho bình quân giá trị khối ngoại bán ra 20 ngày giao dịch trước đó.',
  'algo.tooltip.F_NET_BUY_VOLUME':
    'Được tính bằng khối lượng khối ngoại mua trừ đi khối lượng khối ngoại bán ngày hôm nay',
  'algo.tooltip.AVG_F_NET_BUY_VOL_5D':
    'Được tính bằng trung bình khối lượng khối ngoại mua trừ đi trung bình khối lượng khối ngoại bán 5 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_VOL_10D':
    'Được tính bằng trung bình khối lượng khối ngoại mua trừ đi trung bình khối lượng khối ngoại bán 10 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_VOL_20D':
    'Được tính bằng trung bình khối lượng khối ngoại mua trừ đi trung bình khối lượng khối ngoại bán 20 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_VOL_30D':
    'Được tính bằng trung bình khối lượng khối ngoại mua trừ đi trung bình khối lượng khối ngoại bán 30 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_VOL_60D':
    'Được tính bằng trung bình khối lượng khối ngoại mua trừ đi trung bình khối lượng khối ngoại bán 60 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_VOL_YTD':
    'Được tính bằng trung bình khối lượng khối ngoại mua trừ đi trung bình khối lượng khối ngoại bán từ đầu năm tới hiện tại.',
  'algo.tooltip.AVG_F_NET_BUY_VOL_1Y':
    'Được tính bằng trung bình khối lượng khối ngoại mua trừ đi trung bình khối lượng khối ngoại bán 1 năm gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_5D':
    'Được tính bằng trung bình giá trị khối ngoại mua trừ đi trung bình giá trị khối ngoại bán 5 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_10D':
    'Được tính bằng trung bình giá trị khối ngoại mua trừ đi trung bình giá trị khối ngoại bán 10 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_20D':
    'Được tính bằng trung bình giá trị khối ngoại mua trừ đi trung bình giá trị khối ngoại bán 20 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_30D':
    'Được tính bằng trung bình giá trị khối ngoại mua trừ đi trung bình giá trị khối ngoại bán 30 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_60D':
    'Được tính bằng trung bình giá trị khối ngoại mua trừ đi trung bình giá trị khối ngoại bán 60 ngày giao dịch gần nhất.',
  'algo.tooltip.AVG_F_NET_BUY_YTD':
    'Được tính bằng trung bình giá trị khối ngoại mua trừ đi trung bình giá trị khối ngoại bán từ đầu năm tới hiện tại.',
  'algo.tooltip.AVG_F_NET_BUY_1Y':
    'Được tính bằng trung bình giá trị khối ngoại mua trừ đi trung bình giá trị khối ngoại bán 1 năm gần nhất.',
  'algo.tooltip.MC':
    'Được tính bằng số lượng cổ phiếu đang lưu hành nhân với giá cổ phiếu tại thời điểm tính toán.\nHai yếu tố là số cổ phiếu đang lưu hành và giá cổ phiếu nằm trong file dữ liệu thị trường do HOSE và HASTC cung cấp.',
  'algo.tooltip.EV':
    'EV = Vốn hóa + Nợ ngắn hạn chịu lãi + Nợ dài hạn chịu lãi - Tiền và tương đương tiền – Giá trị thuần đầu tư ngắn hạn\nĐối với công ty thường:\n- Nợ ngắn hạn chịu lãi = Vay ngắn hạn + Giao dịch mua bán lại trái phiếu chính phủ\n- Nợ dài hạn chịu lãi = Vay dài hạn + Trái phiếu chuyển đổi\nĐối với công ty chứng khoán:\n- Nợ ngắn hạn chịu lãi = Vay và nợ thuê tài sản tài chính ngắn hạn + Vay tài sản tài chính ngắn hạn + Trái phiếu chuyển đổi ngắn hạn + Trái phiếu phát hành ngắn hạn + Vay quỹ hỗ trợ thanh toán + Giao dịch mua bán lại trái phiếu chính phủ\n- Nợ dài hạn chịu lãi = Vay và nợ thuê tài sản tài chính dài hạn + Vay tài sản tài chính dài hạn + Trái phiếu chuyển đổi dài hạn + Trái phiếu phát hành dài hạn\nEV không được tính cho các mã thuộc nhóm ngành Ngân hàng và Bảo hiểm.',
  'algo.tooltip.M_SCORE':
    'Được dùng để đánh giá khả năng thao túng lợi nhuận của công ty.\nM-Score lớn hơn -1.78 thể hiện các doanh nghiệp có rủi ro thao túng lợi nhuận cao. \nM-Score không được tính cho Ngân hàng và Bảo hiểm.',
  'algo.tooltip.F_SCORE':
    'Được dùng để chấm điểm sức khỏe tài chính doanh nghiệp theo thang từ 0 đến 9.\nF-Score càng cao thể hiện doanh nghiệp có sức khỏe tài chính càng tốt.',
  'algo.tooltip.Z_SCORE':
    'Được dùng để đánh giá rủi ro phá sản của doanh nghiệp.\nZ >= 2.99: Doanh nghiệp an toàn \n1.8 < Z < 2.99: Cần cẩn thận với doanh nghiệp \nZ <= 1.8: Doanh nghiệp có nguy cơ khủng hoảng\nChỉ tiêu này không được tính cho nhóm Ngân hàng và Bảo hiểm.',
  'algo.tooltip.C_SCORE':
    'Được dùng để đánh giá rủi ro doanh nghiệp xào nấu báo cáo tài chính.\nC-Score càng cao thể hiện doanh nghiệp có rủi ro xào nấu báo cáo tài chính càng cao.',
  'algo.tooltip.MAGIC_SCORE':
    'Bỏ ngành ICB2-Ngân hàng và ICB2-Bảo hiểm\nTính các chỉ số sau:\n- Earning yield = (EBIT 4 quý gần nhất) / EV quý gần nhất\n- ROCE = (EBIT 4 quý gần nhất) / (Bình quân Tổng tài sản 4 quý gần nhất - Bình quân Nợ ngắn hạn 4 quý gần nhất)\nXếp hạng Earning yield, công ty có earning yield cao nhất xếp hạng 1\nXếp hạng ROCE, công ty có ROCE cao nhất xếp hạng 1\nTổng xếp hạng = Xếp hạng Earning yield + Xếp hạng ROCE\nXếp hạng "Tổng xếp hạng", quy về percentile, Công ty có Tổng xếp hạng thấp nhất nhận giá trị 100',
  'algo.tooltip.NET_INC_GROWTH':
    'Được tính bằng (Tổng lợi nhuận ròng 4 quý gần nhất / Tổng lợi nhuận ròng 4 quý cùng kỳ trước đó - 1).\nVí dụ: Lợi nhuận ròng Q4.2018-Q3.2019 / Lợi nhuận ròng Q4.2017-Q3.2018 - 1',
  'algo.tooltip.EPS_GROWTH':
    'Được tính bằng (EPS 4 quý gần nhất / EPS 4 quý cùng kỳ trước đó - 1).\nVí dụ: EPS Q4.2018-Q3.2019 / EPS Q4.2017-Q3.2018 - 1',
  'algo.tooltip.REV_GROWTH_1Y':
    'Được tính bằng (Tổng doanh thu 4 quý gần nhất / Tổng doanh thu 4 quý cùng kỳ trước đó - 1).\nVí dụ: Doanh thu Q4.2018-Q3.2019 / Doanh thu Q4.2017-Q3.2018 - 1',
  'algo.tooltip.DVD_GROWTH':
    'Được tính bằng (DPS 4 quý gần nhất / DPS 4 quý cùng kỳ trước đó - 1).\nVí dụ: DPS Q4.2018-Q3.2019 / DPS Q4.2017-Q3.2018 - 1',
  'algo.tooltip.OPERATING_INC_GROWTH':
    'Được tính bằng (Tổng lợi nhuận từ hoạt động kinh doanh 4 quý gần nhất / Tổng lợi nhuận từ hoạt động kinh doanh 4 quý cùng kỳ trước đó - 1).\nVí dụ: Lợi nhuận từ hoạt động kinh doanh Q4.2018-Q3.2019 / Lợi nhuận từ hoạt động kinh doanh Q4.2017-Q3.2018 - 1',
  'algo.tooltip.GR_PROFIT_GROWTH':
    'Được tính bằng (Tổng lợi nhuận gộp 4 quý gần nhất / Tổng lợi nhuận gộp 4 quý cùng kỳ trước đó - 1).\nVí dụ: Lợi nhuận gộp Q4.2018-Q3.2019 / Lợi nhuận gộp Q4.2017-Q3.2018 - 1',
  'algo.tooltip.NET_INC_GROWTH1':
    'Được tính bằng (Lợi nhuận ròng quý gần nhất / Lợi nhuận ròng quý cùng kỳ năm trước - 1).\nVí dụ: Lợi nhuận ròng Q2.2019 / Lợi nhuận ròng Q2.2018 - 1',
  'algo.tooltip.REV_GROWTH1':
    'Được tính bằng (Doanh thu quý gần nhất / Doanh thu quý cùng kỳ năm trước - 1).\nVí dụ: Doanh thu Q2.2019 / Doanh thu Q2.2018 - 1',
  'algo.tooltip.OPERATING_INC_GROWTH1':
    'Được tính bằng (Lợi nhuận từ hoạt động kinh doanh quý gần nhất / Lợi nhuận từ hoạt động kinh doanh quý cùng kỳ năm trước - 1).\nVí dụ: Lợi nhuận từ hoạt động kinh doanh Q2.2019 / Lợi nhuận từ hoạt động kinh doanh Q2.2018 - 1',
  'algo.tooltip.GR_PROFIT_GROWTH1':
    'Được tính bằng (Lợi nhuận gộp quý gần nhất / Lợi nhuận gộp quý cùng kỳ năm trước - 1).\nVí dụ: Lợi nhuận gộp Q2.2019 / Lợi nhuận gộp Q2.2018 - 1',
  'algo.tooltip.RSI_14':
    'Relative Strength Index (RSI) là chỉ báo động lượng đo lường tốc độ và sự thay đổi của biến động giá. RSI dao động giữa 0 và 100. RSI được coi là quá mua khi lớn hơn 70 và được coi là quá bán khi nhỏ hơn 30.',
  'algo.tooltip.STOCHASTIC_14_3_3':
    'Stochastic Oscillator (STOCH) là chỉ báo động lượng cho biết vị trí của giá đóng cửa so với khoảng giá cao-giá thấp qua một giai đoạn. STOCH có thể được sử dụng để dự báo sự đảo chiều và xác định mức quá mua, quá bán. Giá trị được đưa vào bộ lọc là Full %K.',
  'algo.tooltip.ADI_14':
    'Average Directional Index (ADX) là chỉ báo được sử dụng để xác định xu hướng và độ mạnh của xu hướng. ADX lớn hơn 20 cho thấy đang có xu hướng về giá xảy ra.',
  'algo.tooltip.STOCHASTIC_RSI_14':
    'Stochastic RSI (STOCHRSI) là chỉ báo dao động đo lường mức RSI so với khoảng cao-thấp qua một giai đoạn. STOCHRSI áp dụng công thức Stochastic cho giá trị RSI thay vì giá cổ phiếu, khiến nó trở thành một chỉ báo của chỉ báo. STOCHRSI dao động giữa 0 và 1, được coi là quá mua khi giá trị lớn hơn 0.8 và quá bán khi giá trị nhỏ hơn 0.2.',
  'algo.tooltip.ATR_14':
    'Average True Range (ATR) là chỉ báo đo độ biến động của chứng khoán, xử lý được vấn đề nhảy gap của các mã.',
  'algo.tooltip.WILLIAMR_14':
    'William %R là chỉ báo động lượng phản ánh vị trí của giá đóng cửa so với giá cao cao nhất trong một khoảng thời gian. Chỉ báo này dao động giữa -100 và 0, với khoảng từ 0 đến -20 được coi là quá mua và khoảng từ -100 đến -80 được coi là mức quá bán.',
  'algo.tooltip.MACD_12_26_9':
    'Moving Average Convergence / Divergence Oscillator (MACD) là một trong những chỉ báo động lượng đơn giản và hiệu quả nhất. MACD biến hai chỉ báo xu hướng (hai đường trung bình động) thành một chỉ báo động lượng bằng cách trừ đường trung bình động dài cho đường trung bình động ngắn. Do đó, MACD vừa theo xu hướng vừa dao động. MACD lớn hơn 0 được coi là xu hướng tăng và MACD nhỏ hơn 0 được coi là xu hướng giảm.',
  'algo.tooltip.MFI_14':
    'Money Flow Index (MFI) là chỉ báo dao động sử dụng cả giá và khối lượng để đo lường áp lực mua và bán. MFI bắt đầu bằng việc tính typical price cho mỗi giai đoạn. Money flow dương khi typical price tăng (áp lực mua) và âm khi typical price giảm (áp lực bán). Tỷ số giữa money flow dương và âm sau đó được đưa vào công thức RSI để tạo ra một dao động giữa 0 và 100. MFI được sử dụng để xác định sự đảo chiều khi dùng cùng nhiều chỉ báo khác.',
  'algo.tooltip.BBAND_20_2':
    'Bollinger Band %B xác định vị trí của giá chứng khoán so với đường Band trên và Band dưới của Bollinger Band. Có 3 vị trí cơ bản:\n- %B nhỏ hơn 0 khi giá nhỏ hơn đường Band dưới.\n- %B nằm trong khoảng từ 0 đến 1 khi giá nằm giữa đường Band trên và Band dưới.\n- %B lớn hơn 1 khi giá lớn hơn đường Band trên.\nChứng khoán được coi là quá mua khi %B lớn hơn 1 và quá bán khi %B nhỏ hơn 1.',
  'algo.tooltip.MA_ENVELOPES_20_25':
    'Moving Average Envelopes là các đường envelope dựa trên phần trăm được đặt trên và dưới một đường trung bình động đơn giản. Mỗi đường envelope được đặt cùng phần trăm lớn hơn hoặc nhỏ hơn đường trung bình động. Việc này tạo ra các đường song song và chạy theo biến động giá. Movong Average Envelopes có thể được sử dụng để xác định xu hướng giá cũng như mức quá mua, quá bán.\nMoving Average Envelopes %E xác định vị trí của giá chứng khoán so với đường Band trên và Band dưới của Moving Average Envelopes. Có 3 vị trí cơ bản:\n- %E nhỏ hơn 0 khi giá nhỏ hơn đường Band dưới.\n- %E nằm trong khoảng từ 0 đến 1 khi giá nằm giữa đường Band trên và Band dưới.\n- %E lớn hơn 1 khi giá lớn hơn đường Band trên.\nChứng khoán được coi là quá mua khi %E lớn hơn 1 và quá bán khi %E nhỏ hơn 1.',
  'algo.tooltip.P_PER_SMA10':
    'Được tính bằng cách lấy Giá hiện tại chia cho SMA của 10 ngày giao dịch trước đó.\n- Giá trị lớn hơn 1 khi giá lớn hơn SMA (10)\n- Giá trị bằng 1 khi Giá bằng SMA (10)\n- Giá trị nhỏ hơn 1 khi Giá nhỏ hơn SMA (10)',
  'algo.tooltip.P_PER_EMA10':
    'Được tính bằng cách lấy Giá hiện tại chia cho EMA của 10 ngày giao dịch trước đó.\n- Giá trị lớn hơn 1 khi giá lớn hơn EMA (10)\n- Giá trị bằng 1 khi Giá bằng EMA (10)\n- Giá trị nhỏ hơn 1 khi Giá nhỏ hơn EMA (10)',
  'algo.tooltip.P_PER_DEMA10':
    'Được tính bằng cách lấy Giá hiện tại chia cho DEMA của 10 ngày giao dịch trước đó.\n- Giá trị lớn hơn 1 khi giá lớn hơn DEMA (10)\n- Giá trị bằng 1 khi Giá bằng DEMA (10)\n- Giá trị nhỏ hơn 1 khi Giá nhỏ hơn DEMA (10)',
  'algo.tooltip.P_PER_WMA10':
    'Được tính bằng cách lấy Giá hiện tại chia cho WMA của 10 ngày giao dịch trước đó.\n- Giá trị lớn hơn 1 khi giá lớn hơn WMA (10)\n- Giá trị bằng 1 khi Giá bằng WMA (10)\n- Giá trị nhỏ hơn 1 khi Giá nhỏ hơn WMA (10)',
  'algo.tooltip.SMA5_PER_SMA20':
    'Được tính bằng cách lấy SMA 5 ngày giao dịch trước đó chia cho SMA của 20 ngày giao dịch trước đó.\n- Giá trị lớn hơn 1 khi SMA (5) lớn hơn SMA (20)\n- Giá trị bằng 1 khi SMA (5) bằng SMA (20)\n- Giá trị nhỏ hơn 1 khi SMA (5) nhỏ hơn SMA (20)',
  'algo.tooltip.EMA5_PER_EMA20':
    'Được tính bằng cách lấy EMA 5 ngày giao dịch trước đó chia cho EMA của 20 ngày giao dịch trước đó.\n- Giá trị lớn hơn 1 khi EMA (5) lớn hơn EMA (20)\n- Giá trị bằng 1 khi EMA (5) bằng EMA (20)\n- Giá trị nhỏ hơn 1 khi EMA (5) nhỏ hơn EMA (20)',
  'algo.tooltip.DEMA5_PER_DEMA20':
    'Được tính bằng cách lấy DEMA 5 ngày giao dịch trước đó chia cho DEMA của 20 ngày giao dịch trước đó.\n- Giá trị lớn hơn 1 khi DEMA (5) lớn hơn DEMA (20)\n- Giá trị bằng 1 khi DEMA (5) bằng DEMA (20)\n- Giá trị nhỏ hơn 1 khi DEMA (5) nhỏ hơn DEMA (20)',
  'algo.tooltip.WMA5_PER_WMA20':
    'Được tính bằng cách lấy WMA 5 ngày giao dịch trước đó chia cho WMA của 20 ngày giao dịch trước đó.\n- Giá trị lớn hơn 1 khi WMA (5) lớn hơn WMA (20)\n- Giá trị bằng 1 khi WMA (5) bằng WMA (20)\n- Giá trị nhỏ hơn 1 khi WMA (5) nhỏ hơn WMA (20)',
};
